<template>
  <WorkspaceRoleDenied v-if="staffDenied" :area="t('configuracoes.area')" />
  <div v-else class="workspace-configuracoes-page">
    <!-- Header moderno -->
    <div class="modern-header">
      <div class="header-container">
        <!-- Breadcrumb e navegação -->
        <div class="breadcrumb-section">
          <nav class="breadcrumb">
            <button @click="$router.push('/dashboard')" class="breadcrumb-item">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
              </svg>
              {{ t('common.breadcrumb.dashboard') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <button @click="$router.push(`/workspace/${workspaceId}/dashboard`)" class="breadcrumb-item">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              {{ currentWorkspace?.nome || t('workspaceDashboard.defaultName') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ t('configuracoes.breadcrumbCurrent') }}</span>
          </nav>
        </div>

        <!-- Título e informações principais -->
        <div class="title-section">
          <div class="title-content">
            <div class="title-icon">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
            </div>
            <div class="title-text">
              <h1 class="main-title">{{ t('configuracoes.title') }}</h1>
              <p class="subtitle">{{ t('configuracoes.subtitle') }}</p>
            </div>
          </div>
          
          <!-- Badge do tipo de workspace -->
          <div class="workspace-badge" :class="`type-${currentWorkspace?.tipo?.toLowerCase()}`">
            <div class="badge-icon">
              <svg v-if="currentWorkspace?.tipo === 'CRM'" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
              <svg v-else class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>
              </svg>
            </div>
            <span class="badge-text">{{ currentWorkspace?.tipo || 'TAREFAS' }}</span>
          </div>
        </div>

        <!-- Ações do header -->
        <div class="actions-section">
          <span
            class="workspace-id-chip"
            :title="t('configuracoes.workspaceId')"
          >
            <span class="workspace-id-chip__label">{{ t('configuracoes.workspaceIdShort') }}</span>
            <span class="workspace-id-chip__value">{{ workspaceId }}</span>
          </span>
          <button 
            @click="showImportModal = true"
            class="action-button secondary"
            :disabled="loading"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"/>
            </svg>
            {{ t('configuracoes.import') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Criar Motivo de Agendamento -->
    <div v-if="showCreateMotivoModal" class="modal-overlay" @click="showCreateMotivoModal = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ t('configuracoes.modalCreateMotivo') }}</h3>
          <button @click="showCreateMotivoModal = false" class="modal-close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>{{ t('configuracoes.motivoLabel') }}</label>
            <input v-model="novoMotivo.motivo" type="text" class="input-field" :placeholder="t('configuracoes.placeholderMeeting')" />
          </div>
          <div class="form-group">
            <TagColorSelector v-model="novoMotivo.cor" :disabled="loading" />
          </div>
          <div class="form-group">
            <TagIconSelector v-model="novoMotivo.icone" :disabled="loading" />
          </div>
        </div>
        <div class="modal-footer">
          <button @click="showCreateMotivoModal = false" class="btn-secondary">{{ t('common.cancel') }}</button>
          <button @click="criarMotivo" class="btn-primary" :disabled="!novoMotivo.motivo || loading">
            <span v-if="loading">{{ t('configuracoes.creating') }}</span>
            <span v-else>{{ t('configuracoes.createMotivo') }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Editar Motivo de Agendamento -->
    <div v-if="showEditMotivoModal" class="modal-overlay" @click="showEditMotivoModal = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ t('configuracoes.modalEditMotivo') }}</h3>
          <button @click="showEditMotivoModal = false" class="modal-close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>{{ t('configuracoes.motivoLabel') }}</label>
            <input v-model="motivoEditando.motivo" type="text" class="input-field" :placeholder="t('configuracoes.placeholderMeeting')" />
          </div>
          <div class="form-group">
            <TagColorSelector v-model="motivoEditando.cor" :disabled="loading" />
          </div>
          <div class="form-group">
            <TagIconSelector v-model="motivoEditando.icone" :disabled="loading" />
          </div>
        </div>
        <div class="modal-footer">
          <button @click="showEditMotivoModal = false" class="btn-secondary">{{ t('common.cancel') }}</button>
          <button @click="atualizarMotivo" class="btn-primary" :disabled="!motivoEditando.motivo || loading">
            <span v-if="loading">{{ t('configuracoes.saving') }}</span>
            <span v-else>{{ t('configuracoes.saveChanges') }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Criar Origem de Lead -->
    <div v-if="showCreateOrigemModal" class="modal-overlay" @click="showCreateOrigemModal = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ t('configuracoes.modalCreateOrigem') }}</h3>
          <button @click="showCreateOrigemModal = false" class="modal-close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>{{ t('configuracoes.origemLabel') }}</label>
            <input v-model="novaOrigem.origem" type="text" class="input-field" :placeholder="t('configuracoes.placeholderInstagram')" />
          </div>
          <div class="form-group">
            <LeadSourceIconSelector v-model="novaOrigem.icone" :disabled="loading" />
          </div>
        </div>
        <div class="modal-footer">
          <button @click="showCreateOrigemModal = false" class="btn-secondary">{{ t('common.cancel') }}</button>
          <button @click="criarOrigem" class="btn-primary" :disabled="!novaOrigem.origem || loading">
            <span v-if="loading">{{ t('configuracoes.creating') }}</span>
            <span v-else>{{ t('configuracoes.createOrigem') }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Editar Origem de Lead -->
    <div v-if="showEditOrigemModal" class="modal-overlay" @click="showEditOrigemModal = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ t('configuracoes.modalEditOrigem') }}</h3>
          <button @click="showEditOrigemModal = false" class="modal-close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>{{ t('configuracoes.origemLabel') }}</label>
            <input v-model="origemEditando.origem" type="text" class="input-field" :placeholder="t('configuracoes.placeholderInstagram')" />
          </div>
          <div class="form-group">
            <LeadSourceIconSelector v-model="origemEditando.icone" :disabled="loading" />
          </div>
        </div>
        <div class="modal-footer">
          <button @click="showEditOrigemModal = false" class="btn-secondary">{{ t('common.cancel') }}</button>
          <button @click="atualizarOrigem" class="btn-primary" :disabled="!origemEditando.origem || loading">
            <span v-if="loading">{{ t('configuracoes.saving') }}</span>
            <span v-else>{{ t('configuracoes.saveChanges') }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Conteúdo Principal -->
    <div class="page-content">
      <div class="config-sections">

        <!-- Seção Configurações Avançadas da Task/Kanban (somente workspace de tarefas) -->
        <div v-if="currentWorkspace?.tipo === 'TAREFAS'" class="config-section">
          <div class="section-header">
            <div class="section-title">
              <div class="title-icon">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-7-7h7m0 0v7m0-7L10 15"/>
                </svg>
              </div>
              <div class="title-content">
                <h2>{{ t('configuracoes.advancedTitle') }}</h2>
                <p>{{ t('configuracoes.advancedSubtitle') }}</p>
              </div>
            </div>
            <button class="add-btn" @click="salvarUiConfig">
              {{ t('configuracoes.saveConfig') }}
            </button>
          </div>

          <div class="advanced-tabs">
            <button
              type="button"
              class="advanced-tab-btn"
              :class="{ active: advancedTaskTab === 'desktop' }"
              @click="advancedTaskTab = 'desktop'"
            >
              {{ t('configuracoes.tabDesktop') }}
            </button>
            <button
              type="button"
              class="advanced-tab-btn"
              :class="{ active: advancedTaskTab === 'mobile' }"
              @click="advancedTaskTab = 'mobile'"
            >
              {{ t('configuracoes.tabMobile') }}
            </button>
            <button
              type="button"
              class="advanced-tab-btn"
              :class="{ active: advancedTaskTab === 'forms' }"
              @click="advancedTaskTab = 'forms'"
            >
              {{ t('configuracoes.tabForms') }}
            </button>
            <button
              type="button"
              class="advanced-tab-btn"
              :class="{ active: advancedTaskTab === 'preview' }"
              @click="advancedTaskTab = 'preview'"
            >
              {{ t('configuracoes.tabPreview') }}
            </button>
          </div>

          <PlanFeatureGate :blocked="advancedTabPlanBlocked">
          <div v-if="advancedTaskTab === 'desktop'" class="form-group">
            <label>{{ t('configuracoes.taskFieldsDesktop') }}</label>
            <p class="preview-helper-text">{{ t('configuracoes.taskFieldsDesktopHint') }}</p>
            <div class="task-layout-grid">
              <div class="task-layout-column">
                <div class="task-layout-column-header">{{ t('configuracoes.column1') }}</div>
                <draggable
                  v-model="taskLayout.col1"
                  item-key="id"
                  group="task-layout"
                  handle=".drag-handle"
                  class="task-layout-dropzone"
                  :animation="150"
                  @change="syncTaskLayoutJson"
                >
                  <template #item="{ element }">
                    <div class="task-layout-card" :class="{ 'is-disabled': !element.enabled }">
                      <div class="task-layout-card-main">
                        <button type="button" class="drag-handle" :title="t('configuracoes.dragTitle')">
                          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                            <circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/>
                            <circle cx="9" cy="10" r="1.5"/><circle cx="15" cy="10" r="1.5"/>
                            <circle cx="9" cy="15" r="1.5"/><circle cx="15" cy="15" r="1.5"/>
                            <circle cx="9" cy="20" r="1.5"/><circle cx="15" cy="20" r="1.5"/>
                          </svg>
                        </button>
                        <div class="task-layout-card-info">
                          <span class="task-layout-card-title">{{ element.label }}</span>
                          <span class="task-layout-card-desc">{{ element.description }}</span>
                        </div>
                      </div>
                      <button type="button" class="preview-toggle-switch" :class="{ active: element.enabled }" @click="toggleTaskField(element.id)">
                        <span class="preview-toggle-slider"></span>
                      </button>
                    </div>
                  </template>
                </draggable>
              </div>

              <div class="task-layout-column">
                <div class="task-layout-column-header">{{ t('configuracoes.column2') }}</div>
                <draggable
                  v-model="taskLayout.col2"
                  item-key="id"
                  group="task-layout"
                  handle=".drag-handle"
                  class="task-layout-dropzone"
                  :animation="150"
                  @change="syncTaskLayoutJson"
                >
                  <template #item="{ element }">
                    <div class="task-layout-card" :class="{ 'is-disabled': !element.enabled }">
                      <div class="task-layout-card-main">
                        <button type="button" class="drag-handle" :title="t('configuracoes.dragTitle')">
                          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                            <circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/>
                            <circle cx="9" cy="10" r="1.5"/><circle cx="15" cy="10" r="1.5"/>
                            <circle cx="9" cy="15" r="1.5"/><circle cx="15" cy="15" r="1.5"/>
                            <circle cx="9" cy="20" r="1.5"/><circle cx="15" cy="20" r="1.5"/>
                          </svg>
                        </button>
                        <div class="task-layout-card-info">
                          <span class="task-layout-card-title">{{ element.label }}</span>
                          <span class="task-layout-card-desc">{{ element.description }}</span>
                        </div>
                      </div>
                      <button type="button" class="preview-toggle-switch" :class="{ active: element.enabled }" @click="toggleTaskField(element.id)">
                        <span class="preview-toggle-slider"></span>
                      </button>
                    </div>
                  </template>
                </draggable>
              </div>

              <div class="task-layout-column">
                <div class="task-layout-column-header">{{ t('configuracoes.column3') }}</div>
                <div class="task-layout-dropzone">
                  <div class="task-layout-card" :class="{ 'is-disabled': !taskLayout.chat.enabled }">
                    <div class="task-layout-card-main">
                      <div class="drag-handle drag-handle-disabled" :title="t('configuracoes.fixedPosition')">
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/>
                          <circle cx="9" cy="10" r="1.5"/><circle cx="15" cy="10" r="1.5"/>
                          <circle cx="9" cy="15" r="1.5"/><circle cx="15" cy="15" r="1.5"/>
                          <circle cx="9" cy="20" r="1.5"/><circle cx="15" cy="20" r="1.5"/>
                        </svg>
                      </div>
                      <div class="task-layout-card-info">
                        <span class="task-layout-card-title">{{ t('configuracoes.chatHistory') }}</span>
                        <span class="task-layout-card-desc">{{ t('configuracoes.chatFixedColumn') }}</span>
                      </div>
                    </div>
                    <button type="button" class="preview-toggle-switch" :class="{ active: taskLayout.chat.enabled }" @click="toggleChatCard">
                      <span class="preview-toggle-slider"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="advancedTaskTab === 'mobile'" class="form-group">
            <label>{{ t('configuracoes.taskFieldsMobile') }}</label>
            <p class="preview-helper-text">{{ t('configuracoes.taskFieldsMobileHint') }}</p>
            <div class="task-layout-grid task-layout-grid-mobile">
              <div class="task-layout-column">
                <div class="task-layout-column-header">{{ t('configuracoes.columnMobile') }}</div>
                <draggable
                  v-model="taskLayoutMobile.col1"
                  item-key="id"
                  group="task-layout-mobile"
                  handle=".drag-handle"
                  class="task-layout-dropzone"
                  :animation="150"
                  @change="syncTaskLayoutJson"
                >
                  <template #item="{ element }">
                    <div class="task-layout-card" :class="{ 'is-disabled': !element.enabled }">
                      <div class="task-layout-card-main">
                        <button type="button" class="drag-handle" :title="t('configuracoes.dragTitle')">
                          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                            <circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/>
                            <circle cx="9" cy="10" r="1.5"/><circle cx="15" cy="10" r="1.5"/>
                            <circle cx="9" cy="15" r="1.5"/><circle cx="15" cy="15" r="1.5"/>
                            <circle cx="9" cy="20" r="1.5"/><circle cx="15" cy="20" r="1.5"/>
                          </svg>
                        </button>
                        <div class="task-layout-card-info">
                          <span class="task-layout-card-title">{{ element.label }}</span>
                          <span class="task-layout-card-desc">{{ element.description }}</span>
                        </div>
                      </div>
                      <button type="button" class="preview-toggle-switch" :class="{ active: element.enabled }" @click="toggleTaskField(element.id, 'mobile')">
                        <span class="preview-toggle-slider"></span>
                      </button>
                    </div>
                  </template>
                </draggable>
              </div>

              <div class="task-layout-column">
                <div class="task-layout-column-header">{{ t('configuracoes.chatMobile') }}</div>
                <div class="task-layout-dropzone">
                  <div class="task-layout-card" :class="{ 'is-disabled': !taskLayoutMobile.chat.enabled }">
                    <div class="task-layout-card-main">
                      <div class="drag-handle drag-handle-disabled" :title="t('configuracoes.chatMobileAccess')">
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/>
                          <circle cx="9" cy="10" r="1.5"/><circle cx="15" cy="10" r="1.5"/>
                          <circle cx="9" cy="15" r="1.5"/><circle cx="15" cy="15" r="1.5"/>
                          <circle cx="9" cy="20" r="1.5"/><circle cx="15" cy="20" r="1.5"/>
                        </svg>
                      </div>
                      <div class="task-layout-card-info">
                        <span class="task-layout-card-title">{{ t('configuracoes.chatHistory') }}</span>
                        <span class="task-layout-card-desc">{{ t('configuracoes.chatMobileHeader') }}</span>
                      </div>
                    </div>
                    <button type="button" class="preview-toggle-switch" :class="{ active: taskLayoutMobile.chat.enabled }" @click="toggleChatCard('mobile')">
                      <span class="preview-toggle-slider"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="advancedTaskTab === 'forms'" class="form-group">
            <label>{{ t('configuracoes.tabForms') }}</label>
            <p class="preview-helper-text">{{ t('configuracoes.customFormsHint') }}</p>

            <div class="custom-forms-toolbar">
              <button type="button" class="btn-secondary" @click="addCustomFormGroup">{{ t('configuracoes.newGroup') }}</button>
              <button type="button" class="btn-primary" @click="openCustomFormsPreview">{{ t('configuracoes.preview') }}</button>
            </div>

            <draggable
              v-model="customFormGroups"
              item-key="id"
              handle=".group-drag-handle"
              class="custom-groups-list"
              :animation="150"
              @change="syncCustomFormsJson"
            >
              <template #item="{ element: group }">
                <div class="custom-group-card">
                  <div class="custom-group-header">
                    <div class="custom-group-title-wrap">
                      <button type="button" class="group-drag-handle" :title="t('configuracoes.dragGroup')">
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/>
                          <circle cx="9" cy="10" r="1.5"/><circle cx="15" cy="10" r="1.5"/>
                          <circle cx="9" cy="15" r="1.5"/><circle cx="15" cy="15" r="1.5"/>
                          <circle cx="9" cy="20" r="1.5"/><circle cx="15" cy="20" r="1.5"/>
                        </svg>
                      </button>
                      <input
                        v-model="group.nome"
                        class="input-field"
                        type="text"
                        :placeholder="t('configuracoes.groupNamePlaceholder')"
                        @input="onCustomGroupNameInput"
                      />
                    </div>
                    <button type="button" class="action-btn delete" @click="removeCustomFormGroup(group.id)">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                  </div>

                  <draggable
                    v-model="group.campos"
                    item-key="id"
                    handle=".field-drag-handle"
                    class="custom-fields-list"
                    :animation="150"
                    @change="syncCustomFormsJson"
                  >
                    <template #item="{ element: field }">
                      <div class="custom-field-item">
                        <button type="button" class="field-drag-handle" :title="t('configuracoes.dragField')">
                          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                            <circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/>
                            <circle cx="9" cy="10" r="1.5"/><circle cx="15" cy="10" r="1.5"/>
                            <circle cx="9" cy="15" r="1.5"/><circle cx="15" cy="15" r="1.5"/>
                            <circle cx="9" cy="20" r="1.5"/><circle cx="15" cy="20" r="1.5"/>
                          </svg>
                        </button>
                        <select v-model="field.tipo" class="input-field field-type-select" @change="syncCustomFormsJson">
                          <option value="input">{{ t('configuracoes.fieldTypeInput') }}</option>
                          <option value="textarea">{{ t('configuracoes.fieldTypeTextarea') }}</option>
                          <option value="date">{{ t('configuracoes.fieldTypeDate') }}</option>
                          <option value="checkbox">{{ t('configuracoes.fieldTypeCheckbox') }}</option>
                          <option value="toggle">{{ t('configuracoes.fieldTypeToggle') }}</option>
                          <option value="select">{{ t('configuracoes.fieldTypeSelect') }}</option>
                        </select>
                        <input
                          v-model="field.label"
                          type="text"
                          class="input-field"
                          :placeholder="t('configuracoes.fieldLabelPlaceholder')"
                          @input="syncCustomFormsJson"
                        />
                        <input
                          v-if="field.tipo === 'select'"
                          v-model="field.opcoes"
                          type="text"
                          class="input-field"
                          :placeholder="t('configuracoes.optionsComma')"
                          @input="syncCustomFormsJson"
                        />
                        <button type="button" class="action-btn delete" @click="removeCustomField(group.id, field.id)">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                          </svg>
                        </button>
                      </div>
                    </template>
                  </draggable>

                  <div class="custom-group-actions">
                    <button type="button" class="btn-secondary" @click="addCustomField(group.id)">{{ t('configuracoes.addField') }}</button>
                  </div>
                </div>
              </template>
            </draggable>
          </div>
          <div v-if="advancedTaskTab === 'preview'" class="form-group">
            <label>{{ t('configuracoes.kanbanPreview') }}</label>
            <p class="preview-helper-text">{{ t('configuracoes.kanbanPreviewHint') }}</p>
            <div class="preview-options-grid">
              <div
                v-for="option in previewOptions"
                :key="option.key"
                class="preview-option-item"
              >
                <div class="preview-option-info">
                  <span class="preview-option-label">{{ option.label }}</span>
                  <span class="preview-option-desc">{{ option.description }}</span>
                </div>
                <button
                  type="button"
                  class="preview-toggle-switch"
                  :class="{ 'active': previewSettings[option.key] }"
                  @click="togglePreviewSetting(option.key)"
                >
                  <span class="preview-toggle-slider"></span>
                </button>
              </div>
            </div>
          </div>
          </PlanFeatureGate>
        </div>
        
        <OrcamentoConfigSection
          v-if="currentWorkspace?.tipo === 'CRM'"
          :workspace-id="workspaceId"
          :workspace-tipo="currentWorkspace?.tipo"
        />

        <!-- Seção Tags e Categorias -->
        <PlanFeatureGate :blocked="!planoFeatures.can(planTagsFeatureKey)">
        <div class="config-section">
          <div class="section-header">
            <div class="section-title">
              <div class="title-icon">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
                </svg>
              </div>
              <div class="title-content">
                <h2>{{ t('configuracoes.tagsSectionTitle') }}</h2>
                <p>{{ t('configuracoes.tagsSectionSubtitle') }}</p>
              </div>
            </div>
            <button @click="showCreateCategoriaModal = true" class="add-btn">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
              </svg>
              {{ t('configuracoes.newCategory') }}
            </button>
          </div>

          <div class="categorias-grid" v-if="categorias.length > 0">
            <div 
              v-for="categoria in categorias" 
              :key="categoria.id"
              class="categoria-card"
            >
              <div class="categoria-header">
                <div class="categoria-info">
                  <div class="categoria-icon" style="background-color: #6b7280;">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"/>
                    </svg>
                  </div>
                  <div class="categoria-details">
                    <h3>{{ categoria.nome }}</h3>
                    <p v-if="categoria.descricao">{{ categoria.descricao }}</p>
                    <span class="tags-count">{{ t('configuracoes.tagsCount', { count: categoria.tags?.length || 0 }) }}</span>
                  </div>
                </div>
                <div class="categoria-actions">
                  <button @click="editCategoria(categoria)" class="action-btn edit">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                  </button>
                  <button @click="deleteCategoria(categoria.id)" class="action-btn delete">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
                </div>
              </div>

              <!-- Tags da Categoria -->
              <div class="tags-container">
                <div class="tags-header">
                  <span class="tags-label">{{ t('configuracoes.tagsLabel') }}</span>
                  <button 
                    @click="showCreateTagModal = true; selectedCategoria = categoria"
                    class="add-tag-btn"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
                    </svg>
                  </button>
                </div>
              <div class="tags-list" v-if="categoria.tags && categoria.tags.length > 0">
                <div 
                  v-for="tag in categoria.tags" 
                  :key="tag.id"
                  class="tag-item"
                  :style="{ backgroundColor: tag.cor }"
                >
                    <div class="tag-icon" :style="{ backgroundColor: tag.cor }">
                      <span v-if="tag.icone">{{ getIconEmoji(tag.icone) }}</span>
                      <span v-else>🏷️</span>
                    </div>
                    <span class="tag-name" :style="{ color: getTextColor(tag.cor) }">{{ tag.nome }}</span>
                    <div class="tag-actions">
                      <button @click="editTag(tag)" class="tag-action-btn edit" :title="t('configuracoes.editTag')" :style="{ 
                        color: getTextColor(tag.cor),
                        backgroundColor: getButtonBackgroundColor(tag.cor)
                      }">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                        </svg>
                      </button>
                      <button @click="deleteTag(tag.id)" class="tag-action-btn delete" :title="t('configuracoes.deleteTag')" :style="{ 
                        color: getTextColor(tag.cor),
                        backgroundColor: getButtonBackgroundColor(tag.cor)
                      }">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else class="no-tags">
                  <p>{{ t('configuracoes.noTagsYet') }}</p>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="empty-state">
            <div class="empty-icon">
              <svg class="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
              </svg>
            </div>
            <h3>{{ t('configuracoes.noCategoriesTitle') }}</h3>
            <p>{{ t('configuracoes.noCategoriesDescription') }}</p>
            <button @click="showCreateCategoriaModal = true" class="create-first-btn">
              {{ t('configuracoes.createFirstCategory') }}
            </button>
          </div>
        </div>
        </PlanFeatureGate>

        <!-- Motivos de Agendamento - Card Individual -->
        <PlanFeatureGate :blocked="!planoFeatures.can(planAgendamentoFeatureKey)">
        <div class="config-section">
            <div class="section-header">
              <div class="section-title">
                <div class="title-icon">
                  <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                  </svg>
                </div>
                <div class="title-content">
                  <h2>{{ t('configuracoes.motivosTitle') }}</h2>
                  <p>{{ currentWorkspace?.tipo === 'CRM' ? t('configuracoes.motivosSubtitleCrm') : t('configuracoes.motivosSubtitleTask') }}</p>
                </div>
              </div>
              <button @click="showCreateMotivoModal = true" class="add-btn">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
                </svg>
                {{ t('configuracoes.newMotivo') }}
              </button>
            </div>

            <div class="items-grid" v-if="motivosAgendamento.length > 0">
              <div 
                v-for="motivo in motivosAgendamento" 
                :key="motivo.id"
                class="item-card"
              >
                <div class="item-icon" :style="{ backgroundColor: motivo.cor }">
                  <span v-if="motivo.icone">{{ getIconEmoji(motivo.icone) }}</span>
                  <svg v-else class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
                  </svg>
                </div>
                <div class="item-content">
                  <h3>{{ motivo.motivo }}</h3>
                </div>
                <div class="item-actions">
                  <button @click="editMotivo(motivo)" class="action-btn edit">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                  </button>
                  <button @click="deleteMotivo(motivo.id)" class="action-btn delete">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div v-else class="empty-state">
              <div class="empty-icon">
                <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
              </div>
              <h3>{{ t('configuracoes.noMotivosTitle') }}</h3>
              <p>{{ t('configuracoes.noMotivosDescription') }}</p>
            </div>
        </div>
        </PlanFeatureGate>

        <!-- Origens de Lead - Card Individual -->
        <PlanFeatureGate :blocked="!planoFeatures.can('crmOrigemLead')">
        <div v-if="currentWorkspace?.tipo === 'CRM'" class="config-section">
            <div class="section-header">
              <div class="section-title">
                <div class="title-icon">
                  <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                  </svg>
                </div>
                <div class="title-content">
                  <h2>{{ t('configuracoes.origensTitle') }}</h2>
                  <p>{{ t('configuracoes.origensSubtitle') }}</p>
                </div>
              </div>
              <button @click="showCreateOrigemModal = true" class="add-btn">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
                </svg>
                {{ t('configuracoes.newOrigem') }}
              </button>
            </div>

            <div class="items-grid" v-if="origensLead.length > 0">
              <div 
                v-for="origem in origensLead" 
                :key="origem.id"
                class="item-card"
              >
                <div class="item-icon">
                  <LeadSourceIcons v-if="origem.icone" :name="getLeadSourceIcon(origem.icone)" />
                  <svg v-else class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd"/>
                  </svg>
                </div>
                <div class="item-content">
                  <h3>{{ origem.origem }}</h3>
                </div>
                <div class="item-actions">
                  <button @click="editOrigem(origem)" class="action-btn edit">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                  </button>
                  <button @click="deleteOrigem(origem.id)" class="action-btn delete">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div v-else class="empty-state">
              <div class="empty-icon">
                <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                </svg>
              </div>
              <h3>{{ t('configuracoes.noOrigensTitle') }}</h3>
              <p>{{ t('configuracoes.noOrigensDescription') }}</p>
            </div>
        </div>
        </PlanFeatureGate>
      </div>
    </div>

    <!-- Modais -->
    <!-- Modal de Importação -->
    <div v-if="showImportModal" class="modal-overlay" @click="showImportModal = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ t('configuracoes.importModalTitle') }}</h3>
          <button @click="showImportModal = false" class="modal-close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ t('configuracoes.importModalDescription') }}</p>
          <input 
            v-model="importWorkspaceId" 
            type="number" 
            :placeholder="t('configuracoes.importSourcePlaceholder')"
            class="input-field"
          >
        </div>
        <div class="modal-footer">
          <button @click="showImportModal = false" class="btn-secondary">{{ t('common.cancel') }}</button>
          <button @click="importarConfiguracoes" class="btn-primary" :disabled="!importWorkspaceId || loading">
            <span v-if="loading">{{ t('configuracoes.importing') }}</span>
            <span v-else>{{ t('configuracoes.import') }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Criar Categoria -->
    <div v-if="showCreateCategoriaModal" class="modal-overlay" @click="showCreateCategoriaModal = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ t('configuracoes.createCategory') }}</h3>
          <button @click="showCreateCategoriaModal = false" class="modal-close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>{{ t('configuracoes.categoryName') }}</label>
            <input v-model="novaCategoria.nome" type="text" class="input-field" :placeholder="t('configuracoes.categoryNameExample')">
          </div>
          <div class="form-group">
            <label>{{ t('configuracoes.categoryDescription') }}</label>
            <textarea v-model="novaCategoria.descricao" class="input-field" rows="3" :placeholder="t('configuracoes.optionalDescription')"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="showCreateCategoriaModal = false" class="btn-secondary">{{ t('common.cancel') }}</button>
          <button @click="criarCategoria" class="btn-primary" :disabled="!novaCategoria.nome || loading">
            <span v-if="loading">{{ t('configuracoes.creating') }}</span>
            <span v-else>{{ t('configuracoes.createCategory') }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Editar Categoria -->
    <div v-if="showEditCategoriaModal" class="modal-overlay" @click="showEditCategoriaModal = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ t('configuracoes.editCategory') }}</h3>
          <button @click="showEditCategoriaModal = false" class="modal-close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>{{ t('configuracoes.categoryName') }}</label>
            <input v-model="categoriaEditando.nome" type="text" class="input-field" :placeholder="t('configuracoes.categoryNameExample')">
          </div>
          <div class="form-group">
            <label>{{ t('configuracoes.categoryDescription') }}</label>
            <textarea v-model="categoriaEditando.descricao" class="input-field" rows="3" :placeholder="t('configuracoes.optionalDescription')"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="showEditCategoriaModal = false" class="btn-secondary">{{ t('common.cancel') }}</button>
          <button @click="atualizarCategoria" class="btn-primary" :disabled="!categoriaEditando.nome || loading">
            <span v-if="loading">{{ t('configuracoes.saving') }}</span>
            <span v-else>{{ t('configuracoes.saveChanges') }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Criar Tag -->
    <div v-if="showCreateTagModal" class="modal-overlay" @click="showCreateTagModal = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ t('configuracoes.createTag') }}</h3>
          <button @click="showCreateTagModal = false" class="modal-close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>{{ t('configuracoes.tagName') }}</label>
            <input v-model="novaTag.nome" type="text" class="input-field" :placeholder="t('configuracoes.tagNameExample')">
          </div>
          
          <!-- Seletor Visual de Cor -->
          <div class="form-group">
            <TagColorSelector 
              v-model="novaTag.cor" 
              :disabled="loading"
            />
          </div>
          
          <!-- Seletor Visual de Ícone -->
          <div class="form-group">
            <TagIconSelector 
              v-model="novaTag.icone" 
              :disabled="loading"
            />
          </div>
          
          <!-- Preview da Tag -->
          <div class="form-group" v-if="novaTag.nome || novaTag.cor || novaTag.icone">
            <label class="block text-sm font-medium mb-2">{{ t('configuracoes.tagPreviewLabel') }}</label>
            <div class="tag-preview">
              <div 
                class="tag-item-preview"
                :style="{ backgroundColor: novaTag.cor }"
              >
                <div class="tag-icon-preview" :style="{ backgroundColor: novaTag.cor }">
                  <span v-if="novaTag.icone">{{ getIconEmoji(novaTag.icone) }}</span>
                  <span v-else>🏷️</span>
                </div>
                <span class="tag-name-preview" :style="{ color: getTextColor(novaTag.cor) }">
                  {{ novaTag.nome || t('configuracoes.tagName') }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="showCreateTagModal = false" class="btn-secondary">{{ t('common.cancel') }}</button>
          <button @click="criarTag" class="btn-primary" :disabled="!novaTag.nome || loading">
            <span v-if="loading">{{ t('configuracoes.creating') }}</span>
            <span v-else>{{ t('configuracoes.createTag') }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Editar Tag -->
    <div v-if="showEditTagModal" class="modal-overlay" @click="showEditTagModal = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ t('configuracoes.editTagModal') }}</h3>
          <button @click="showEditTagModal = false" class="modal-close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>{{ t('configuracoes.tagName') }}</label>
            <input v-model="tagEditando.nome" type="text" class="input-field" :placeholder="t('configuracoes.tagNameExample')">
          </div>
          
          <!-- Seletor Visual de Cor -->
          <div class="form-group">
            <TagColorSelector 
              v-model="tagEditando.cor" 
              :disabled="loading"
            />
          </div>
          
          <!-- Seletor Visual de Ícone -->
          <div class="form-group">
            <TagIconSelector 
              v-model="tagEditando.icone" 
              :disabled="loading"
            />
          </div>
          
          <!-- Preview da Tag -->
          <div class="form-group" v-if="tagEditando.nome || tagEditando.cor || tagEditando.icone">
            <label class="block text-sm font-medium mb-2">{{ t('configuracoes.tagPreviewLabel') }}</label>
            <div class="tag-preview">
              <div 
                class="tag-item-preview"
                :style="{ backgroundColor: tagEditando.cor }"
              >
                <div class="tag-icon-preview" :style="{ backgroundColor: tagEditando.cor }">
                  <span v-if="tagEditando.icone">{{ getIconEmoji(tagEditando.icone) }}</span>
                  <span v-else>🏷️</span>
                </div>
                <span class="tag-name-preview" :style="{ color: getTextColor(tagEditando.cor) }">
                  {{ tagEditando.nome || t('configuracoes.tagName') }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="showEditTagModal = false" class="btn-secondary">{{ t('common.cancel') }}</button>
          <button @click="atualizarTag" class="btn-primary" :disabled="!tagEditando.nome || loading">
            <span v-if="loading">{{ t('configuracoes.saving') }}</span>
            <span v-else>{{ t('configuracoes.saveChanges') }}</span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="showCustomFormsPreview" class="modal-overlay" @click="showCustomFormsPreview = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ t('configuracoes.customFormsPreviewTitle') }}</h3>
          <button @click="showCustomFormsPreview = false" class="modal-close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="customFormGroups.length === 0" class="empty-state">
            <h3>{{ t('configuracoes.emptyCustomFormsTitle') }}</h3>
            <p>{{ t('configuracoes.emptyCustomFormsDesc') }}</p>
          </div>
          <div v-else class="custom-preview-list">
            <div v-for="group in customFormGroups" :key="`preview-${group.id}`" class="custom-preview-group">
              <h4 class="custom-preview-group-title">{{ group.nome || t('configuracoes.unnamedGroup') }}</h4>
              <div v-if="!group.campos || group.campos.length === 0" class="custom-preview-empty">{{ t('configuracoes.noFieldsInGroup') }}</div>
              <div v-else class="custom-preview-fields">
                <div v-for="field in group.campos" :key="`field-preview-${field.id}`" class="custom-preview-field">
                  <label class="custom-preview-label">{{ field.label || t('configuracoes.unnamedField') }}</label>
                  <input v-if="field.tipo === 'input'" type="text" class="input-field" :placeholder="field.label || 'Input'" disabled />
                  <textarea v-else-if="field.tipo === 'textarea'" class="input-field" rows="3" :placeholder="field.label || 'Text Area'" disabled></textarea>
                  <input v-else-if="field.tipo === 'date'" type="date" class="input-field" disabled />
                  <label v-else-if="field.tipo === 'checkbox'" class="custom-preview-inline">
                    <input type="checkbox" disabled />
                    <span>{{ t('configuracoes.option') }}</span>
                  </label>
                  <label v-else-if="field.tipo === 'toggle'" class="custom-preview-inline">
                    <span class="preview-toggle-switch"><span class="preview-toggle-slider"></span></span>
                    <span>{{ t('configuracoes.toggleOnOff') }}</span>
                  </label>
                  <select v-else-if="field.tipo === 'select'" class="input-field" disabled>
                    <option>{{ t('configuracoes.selectOption') }}</option>
                    <option v-for="opt in parseSelectOptions(field.opcoes)" :key="opt">{{ opt }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading Overlay -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useGlobalWorkspaces } from '../composables/useGlobalWorkspaces'
import api from '../services/api'
import TagColorSelector from '../components/TagColorSelector.vue'
import TagIconSelector from '../components/TagIconSelector.vue'
import LeadSourceIconSelector from '../components/LeadSourceIconSelector.vue'
import LeadSourceIcons from '../components/icons/LeadSourceIcons.vue'
import { getLeadSourceIcon } from '../utils/leadSourceIconMapper'
import Swal from 'sweetalert2'
import draggable from 'vuedraggable'
import WorkspaceRoleDenied from '../components/workspace/WorkspaceRoleDenied.vue'
import { useWorkspaceStaffGuard } from '../composables/useWorkspaceStaffGuard'
import { usePlanoFeatures } from '../composables/usePlanoFeatures'
import PlanFeatureGate from '../components/plan/PlanFeatureGate.vue'
import OrcamentoConfigSection from '../components/orcamento/OrcamentoConfigSection.vue'

const route = useRoute()
const { currentWorkspace } = useGlobalWorkspaces()
const { t } = useI18n()
const { staffDenied, ensureAccess } = useWorkspaceStaffGuard(t('configuracoes.area'))
const planoFeatures = usePlanoFeatures()

const advancedTabPlanBlocked = computed(() => {
  if (advancedTaskTab.value === 'desktop' || advancedTaskTab.value === 'mobile') {
    return !planoFeatures.can('taskEditLayout')
  }
  if (advancedTaskTab.value === 'forms') return !planoFeatures.can('customForms')
  if (advancedTaskTab.value === 'preview') return !planoFeatures.can('kanbanPreviewMenu')
  return false
})

const planTagsFeatureKey = computed(() => {
  const tipo = String(currentWorkspace.value?.tipo || '').toUpperCase()
  if (tipo === 'CRM') return 'crmTags'
  if (tipo === 'SERVICOS') return 'servicosTags'
  return 'taskTags'
})

const planAgendamentoFeatureKey = computed(() => {
  const tipo = String(currentWorkspace.value?.tipo || '').toUpperCase()
  if (tipo === 'CRM') return 'crmAgendamento'
  if (tipo === 'SERVICOS') return 'servicosAgenda'
  return 'taskAgendamento'
})

// Refs
const loading = ref(false)
const advancedTaskTab = ref('desktop')
const categorias = ref([])
const motivosAgendamento = ref([])
const origensLead = ref([])
const uiConfig = ref({
  taskEditFieldsJson: '{}',
  kanbanFiltersJson: '{}',
  screenPreferencesJson: '{}',
  customFormsJson: '{}',
  taskPreviewJson: '{}'
})

const previewOptionKeys = ['showDescription', 'showTagsExpanded', 'showUsers', 'showActivityControls', 'showSchedule', 'showChecklist', 'showAttachments', 'showCreatedAt', 'showUpdatedAt', 'showFinanceiro', 'showTaskProgress']

const previewOptions = computed(() => previewOptionKeys.map((key) => ({
  key,
  label: t(`configuracoes.previewOptions.${key}.label`),
  description: t(`configuracoes.previewOptions.${key}.description`)
})))

const getDefaultPreviewSettings = () => ({
  showDescription: true,
  showTagsExpanded: true,
  showUsers: true,
  showActivityControls: true,
  showSchedule: true,
  showChecklist: true,
  showAttachments: true,
  showCreatedAt: true,
  showUpdatedAt: true,
  showFinanceiro: true,
  showTaskProgress: true
})

const previewSettings = ref(getDefaultPreviewSettings())
const showCustomFormsPreview = ref(false)

const taskFieldCatalogIds = ['informacoesTask', 'checklist', 'anexos', 'cor', 'financeiro', 'progressoTarefa', 'tags', 'usuariosAtribuidos', 'controlesAtividade', 'agendamento']

const taskFieldCatalog = computed(() => taskFieldCatalogIds.map((id) => ({
  id,
  label: t(`configuracoes.taskFields.${id}.label`),
  description: t(`configuracoes.taskFields.${id}.description`)
})))

const customGroupCardId = (groupId) => `customGroup:${groupId}`
const isCustomGroupCardId = (id) => String(id || '').startsWith('customGroup:')

const buildTaskField = (id, enabled = true) => {
  if (isCustomGroupCardId(id)) {
    const groupId = String(id).replace('customGroup:', '')
    const group = customFormGroups.value.find((item) => String(item.id) === groupId)
    return {
      id,
      label: t('configuracoes.formGroupPrefix', { name: group?.nome || t('configuracoes.customGroupDefault') }),
      description: t('configuracoes.customFieldsDesc'),
      enabled
    }
  }

  const catalog = taskFieldCatalog.value.find((item) => item.id === id)
  return {
    id,
    label: catalog?.label || id,
    description: catalog?.description || '',
    enabled
  }
}

const getDefaultTaskLayout = () => ({
  col1: [
    buildTaskField('informacoesTask'),
    buildTaskField('checklist'),
    buildTaskField('anexos')
  ],
  col2: [
    buildTaskField('cor'),
    buildTaskField('financeiro'),
    buildTaskField('progressoTarefa'),
    buildTaskField('tags'),
    buildTaskField('usuariosAtribuidos'),
    buildTaskField('controlesAtividade'),
    buildTaskField('agendamento')
  ],
  chat: { enabled: true }
})

const getDefaultTaskLayoutMobile = () => {
  const desktop = getDefaultTaskLayout()
  return {
    col1: [...desktop.col1, ...desktop.col2].map((item) => buildTaskField(item.id, item.enabled !== false)),
    chat: { enabled: true }
  }
}

const taskLayout = ref(getDefaultTaskLayout())
const taskLayoutMobile = ref(getDefaultTaskLayoutMobile())

const newFieldId = () => `f_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
const newGroupId = () => `g_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`

const createEmptyCustomField = () => ({
  id: newFieldId(),
  tipo: 'input',
  label: '',
  opcoes: ''
})

const createEmptyCustomGroup = () => ({
  id: newGroupId(),
  nome: '',
  campos: [createEmptyCustomField()]
})

const customFormGroups = ref([])

const getAvailableTaskFieldIds = () => {
  const base = taskFieldCatalogIds
  const custom = customFormGroups.value.map((group) => customGroupCardId(group.id))
  return [...base, ...custom]
}

const ensureBaseTaskCards = (layout) => {
  const existingIds = new Set([...(layout.col1 || []), ...(layout.col2 || [])].map((item) => item.id))
  taskFieldCatalog.value.forEach((base) => {
    if (!existingIds.has(base.id)) {
      layout.col2.push(buildTaskField(base.id, true))
    }
  })
}

const reconcileTaskLayoutWithCustomGroups = () => {
  const customIds = new Set(customFormGroups.value.map((group) => customGroupCardId(group.id)))

  taskLayout.value.col1 = taskLayout.value.col1
    .filter((item) => !isCustomGroupCardId(item.id) || customIds.has(item.id))
    .map((item) => buildTaskField(item.id, item.enabled !== false))

  taskLayout.value.col2 = taskLayout.value.col2
    .filter((item) => !isCustomGroupCardId(item.id) || customIds.has(item.id))
    .map((item) => buildTaskField(item.id, item.enabled !== false))

  const existing = new Set([...taskLayout.value.col1, ...taskLayout.value.col2].map((item) => item.id))
  customIds.forEach((id) => {
    if (!existing.has(id)) {
      taskLayout.value.col2.push(buildTaskField(id, true))
    }
  })

  ensureBaseTaskCards(taskLayout.value)

  taskLayoutMobile.value.col1 = taskLayoutMobile.value.col1
    .filter((item) => !isCustomGroupCardId(item.id) || customIds.has(item.id))
    .map((item) => buildTaskField(item.id, item.enabled !== false))

  const existingMobile = new Set(taskLayoutMobile.value.col1.map((item) => item.id))
  getAvailableTaskFieldIds().forEach((id) => {
    if (!existingMobile.has(id)) {
      taskLayoutMobile.value.col1.push(buildTaskField(id, true))
    }
  })

  syncTaskLayoutJson()
}

// Modais
const showImportModal = ref(false)
const showCreateCategoriaModal = ref(false)
const showEditCategoriaModal = ref(false)
const showCreateTagModal = ref(false)
const showEditTagModal = ref(false)
const showCreateMotivoModal = ref(false)
const showCreateOrigemModal = ref(false)
const showEditMotivoModal = ref(false)
const showEditOrigemModal = ref(false)

// Formulários
const importWorkspaceId = ref('')
const selectedCategoria = ref(null)

const novaCategoria = ref({
  nome: '',
  descricao: '',
  cor: '#5865F2',
  icone: '',
  ordem: 0
})

const categoriaEditando = ref({})

const novaTag = ref({
  nome: '',
  cor: '#5865F2',
  icone: ''
})

const tagEditando = ref({
  id: null,
  nome: '',
  cor: '#5865F2',
  icone: ''
})

const novoMotivo = ref({
  motivo: '',
  cor: '#5865F2',
  icone: ''
})

const novaOrigem = ref({
  origem: '',
  icone: ''
})

const motivoEditando = ref({
  id: null,
  motivo: '',
  cor: '#5865F2',
  icone: ''
})

const origemEditando = ref({
  id: null,
  origem: '',
  icone: ''
})

// Computed
const workspaceId = computed(() => route.params.id)

// Ícones disponíveis - Mesma lista do TagIconSelector
const availableIcons = [
  // Prioridade e Status
  { value: 'priority', emoji: '🔥', label: 'Prioridade' },
  { value: 'urgent', emoji: '⚡', label: 'Urgente' },
  { value: 'important', emoji: '⭐', label: 'Importante' },
  { value: 'critical', emoji: '🚨', label: 'Crítico' },
  { value: 'high', emoji: '🔴', label: 'Alto' },
  { value: 'medium', emoji: '🟡', label: 'Médio' },
  { value: 'low', emoji: '🟢', label: 'Baixo' },
  { value: 'done', emoji: '✅', label: 'Concluído' },
  { value: 'pending', emoji: '⏳', label: 'Pendente' },
  { value: 'blocked', emoji: '🚫', label: 'Bloqueado' },
  { value: 'progress', emoji: '🔄', label: 'Em Progresso' },
  { value: 'review', emoji: '👀', label: 'Revisão' },
  { value: 'approval', emoji: '👍', label: 'Aprovação' },
  { value: 'rejection', emoji: '👎', label: 'Rejeição' },
  { value: 'warning', emoji: '⚠️', label: 'Atenção' },
  { value: 'error', emoji: '❌', label: 'Erro' },
  { value: 'success', emoji: '🎉', label: 'Sucesso' },
  { value: 'info', emoji: 'ℹ️', label: 'Informação' },
  { value: 'question', emoji: '❓', label: 'Dúvida' },
  { value: 'help', emoji: '🆘', label: 'Ajuda' },
  
  // Trabalho e Produtividade
  { value: 'task', emoji: '📋', label: 'Tarefa' },
  { value: 'project', emoji: '📁', label: 'Projeto' },
  { value: 'bug', emoji: '🐛', label: 'Bug' },
  { value: 'feature', emoji: '✨', label: 'Funcionalidade' },
  { value: 'improvement', emoji: '🔧', label: 'Melhoria' },
  { value: 'test', emoji: '🧪', label: 'Teste' },
  { value: 'deploy', emoji: '🚀', label: 'Deploy' },
  { value: 'release', emoji: '🎊', label: 'Release' },
  { value: 'maintenance', emoji: '🔨', label: 'Manutenção' },
  { value: 'security', emoji: '🔒', label: 'Segurança' },
  { value: 'database', emoji: '🗄️', label: 'Banco de Dados' },
  { value: 'api', emoji: '🔌', label: 'API' },
  { value: 'frontend', emoji: '🎨', label: 'Frontend' },
  { value: 'backend', emoji: '⚙️', label: 'Backend' },
  { value: 'mobile', emoji: '📱', label: 'Mobile' },
  { value: 'web', emoji: '🌐', label: 'Web' },
  { value: 'desktop', emoji: '💻', label: 'Desktop' },
  
  // Comunicação e Colaboração
  { value: 'meeting', emoji: '📅', label: 'Reunião' },
  { value: 'call', emoji: '📞', label: 'Ligação' },
  { value: 'email', emoji: '📧', label: 'Email' },
  { value: 'chat', emoji: '💬', label: 'Chat' },
  { value: 'team', emoji: '👥', label: 'Equipe' },
  { value: 'client', emoji: '👤', label: 'Cliente' },
  { value: 'admin', emoji: '👑', label: 'Admin' },
  { value: 'manager', emoji: '👔', label: 'Gerente' },
  { value: 'developer', emoji: '👨‍💻', label: 'Desenvolvedor' },
  { value: 'designer', emoji: '🎨', label: 'Designer' },
  { value: 'analyst', emoji: '📊', label: 'Analista' },
  { value: 'consultant', emoji: '💼', label: 'Consultor' },
  { value: 'support', emoji: '🆘', label: 'Suporte' },
  { value: 'training', emoji: '🎓', label: 'Treinamento' },
  { value: 'documentation', emoji: '📚', label: 'Documentação' },
  { value: 'tutorial', emoji: '📖', label: 'Tutorial' },
  { value: 'guide', emoji: '🗺️', label: 'Guia' },
  { value: 'manual', emoji: '📘', label: 'Manual' },
  
  // Tempo e Organização
  { value: 'clock', emoji: '⏰', label: 'Tempo' },
  { value: 'calendar', emoji: '📆', label: 'Data' },
  { value: 'deadline', emoji: '⏳', label: 'Prazo' },
  { value: 'reminder', emoji: '🔔', label: 'Lembrete' },
  { value: 'event', emoji: '🎯', label: 'Evento' },
  { value: 'milestone', emoji: '🏁', label: 'Marco' },
  { value: 'checkpoint', emoji: '📍', label: 'Checkpoint' },
  { value: 'phase', emoji: '📈', label: 'Fase' },
  { value: 'sprint', emoji: '🏃‍♂️', label: 'Sprint' },
  { value: 'quarter', emoji: '📅', label: 'Trimestre' },
  { value: 'monthly', emoji: '📅', label: 'Mensal' },
  { value: 'weekly', emoji: '📅', label: 'Semanal' },
  { value: 'daily', emoji: '📅', label: 'Diário' },
  
  // Finanças e Negócios
  { value: 'money', emoji: '💰', label: 'Financeiro' },
  { value: 'budget', emoji: '💳', label: 'Orçamento' },
  { value: 'cost', emoji: '💸', label: 'Custo' },
  { value: 'revenue', emoji: '💵', label: 'Receita' },
  { value: 'profit', emoji: '📈', label: 'Lucro' },
  { value: 'investment', emoji: '📊', label: 'Investimento' },
  { value: 'sales', emoji: '🛒', label: 'Vendas' },
  { value: 'marketing', emoji: '📢', label: 'Marketing' },
  { value: 'promotion', emoji: '🎯', label: 'Promoção' },
  { value: 'campaign', emoji: '📢', label: 'Campanha' },
  { value: 'lead', emoji: '🎣', label: 'Lead' },
  { value: 'prospect', emoji: '🔍', label: 'Prospect' },
  { value: 'contract', emoji: '📄', label: 'Contrato' },
  { value: 'invoice', emoji: '🧾', label: 'Fatura' },
  { value: 'payment', emoji: '💳', label: 'Pagamento' },
  { value: 'refund', emoji: '↩️', label: 'Reembolso' },
  { value: 'discount', emoji: '🏷️', label: 'Desconto' },
  { value: 'offer', emoji: '🎁', label: 'Oferta' },
  { value: 'deal', emoji: '🤝', label: 'Negócio' },
  
  // Mídia e Conteúdo
  { value: 'website', emoji: '🌐', label: 'Website' },
  { value: 'social', emoji: '📱', label: 'Redes Sociais' },
  { value: 'blog', emoji: '📝', label: 'Blog' },
  { value: 'article', emoji: '📰', label: 'Artigo' },
  { value: 'news', emoji: '📰', label: 'Notícia' },
  { value: 'video', emoji: '🎥', label: 'Vídeo' },
  { value: 'image', emoji: '🖼️', label: 'Imagem' },
  { value: 'audio', emoji: '🎵', label: 'Áudio' },
  { value: 'podcast', emoji: '🎙️', label: 'Podcast' },
  { value: 'livestream', emoji: '📺', label: 'Live' },
  { value: 'webinar', emoji: '🎓', label: 'Webinar' },
  { value: 'course', emoji: '🎓', label: 'Curso' },
  { value: 'ebook', emoji: '📖', label: 'E-book' },
  { value: 'whitepaper', emoji: '📄', label: 'Whitepaper' },
  { value: 'case-study', emoji: '📊', label: 'Case Study' },
  { value: 'infographic', emoji: '📊', label: 'Infográfico' },
  { value: 'brochure', emoji: '📋', label: 'Brochura' },
  { value: 'catalog', emoji: '📚', label: 'Catálogo' },
  
  // Localização e Logística
  { value: 'location', emoji: '📍', label: 'Local' },
  { value: 'office', emoji: '🏢', label: 'Escritório' },
  { value: 'home', emoji: '🏠', label: 'Casa' },
  { value: 'remote', emoji: '🏡', label: 'Remoto' },
  { value: 'travel', emoji: '✈️', label: 'Viagem' },
  { value: 'delivery', emoji: '🚚', label: 'Entrega' },
  { value: 'shipping', emoji: '📦', label: 'Envio' },
  { value: 'warehouse', emoji: '🏭', label: 'Armazém' },
  { value: 'store', emoji: '🏪', label: 'Loja' },
  { value: 'factory', emoji: '🏭', label: 'Fábrica' },
  { value: 'supplier', emoji: '🏭', label: 'Fornecedor' },
  { value: 'vendor', emoji: '🏪', label: 'Vendedor' },
  { value: 'partner', emoji: '🤝', label: 'Parceiro' },
  { value: 'distributor', emoji: '🚛', label: 'Distribuidor' },
  { value: 'retailer', emoji: '🏪', label: 'Varejista' },
  { value: 'wholesale', emoji: '📦', label: 'Atacado' },
  { value: 'import', emoji: '📥', label: 'Importação' },
  { value: 'export', emoji: '📤', label: 'Exportação' },
  { value: 'customs', emoji: '🛂', label: 'Alfândega' },
  { value: 'logistics', emoji: '🚛', label: 'Logística' },
  
  // Tecnologia e Inovação
  { value: 'innovation', emoji: '💡', label: 'Inovação' },
  { value: 'research', emoji: '🔬', label: 'Pesquisa' },
  { value: 'development', emoji: '🔧', label: 'Desenvolvimento' },
  { value: 'prototype', emoji: '🧪', label: 'Protótipo' },
  { value: 'pilot', emoji: '✈️', label: 'Piloto' },
  { value: 'beta', emoji: '🧪', label: 'Beta' },
  { value: 'ai', emoji: '🤖', label: 'IA' },
  { value: 'ml', emoji: '🧠', label: 'Machine Learning' },
  { value: 'blockchain', emoji: '⛓️', label: 'Blockchain' },
  { value: 'crypto', emoji: '₿', label: 'Cripto' },
  { value: 'cloud', emoji: '☁️', label: 'Cloud' },
  { value: 'iot', emoji: '🌐', label: 'IoT' },
  { value: 'ar', emoji: '🥽', label: 'AR' },
  { value: 'vr', emoji: '🥽', label: 'VR' },
  { value: 'automation', emoji: '🤖', label: 'Automação' },
  { value: 'integration', emoji: '🔗', label: 'Integração' },
  { value: 'migration', emoji: '🔄', label: 'Migração' },
  { value: 'upgrade', emoji: '⬆️', label: 'Upgrade' },
  { value: 'downgrade', emoji: '⬇️', label: 'Downgrade' },
  { value: 'rollback', emoji: '↩️', label: 'Rollback' },
  
  // ===== ORIGENS DE LEAD - CRM =====
  // Redes Sociais e Plataformas Digitais
  { value: 'facebook', emoji: '📘', label: 'Facebook' },
  { value: 'instagram', emoji: '📷', label: 'Instagram' },
  { value: 'twitter', emoji: '🐦', label: 'Twitter/X' },
  { value: 'linkedin', emoji: '💼', label: 'LinkedIn' },
  { value: 'youtube', emoji: '📺', label: 'YouTube' },
  { value: 'tiktok', emoji: '🎵', label: 'TikTok' },
  { value: 'whatsapp', emoji: '💬', label: 'WhatsApp' },
  { value: 'telegram', emoji: '✈️', label: 'Telegram' },
  { value: 'discord', emoji: '🎮', label: 'Discord' },
  { value: 'snapchat', emoji: '👻', label: 'Snapchat' },
  { value: 'pinterest', emoji: '📌', label: 'Pinterest' },
  { value: 'reddit', emoji: '🤖', label: 'Reddit' },
  { value: 'twitch', emoji: '🎮', label: 'Twitch' },
  { value: 'clubhouse', emoji: '🏠', label: 'Clubhouse' },
  
  // Motores de Busca e Diretórios
  { value: 'google', emoji: '🔍', label: 'Google' },
  { value: 'bing', emoji: '🔍', label: 'Bing' },
  { value: 'yahoo', emoji: '🔍', label: 'Yahoo' },
  { value: 'duckduckgo', emoji: '🦆', label: 'DuckDuckGo' },
  { value: 'directory', emoji: '📋', label: 'Diretório' },
  { value: 'yellow-pages', emoji: '📞', label: 'Páginas Amarelas' },
  { value: 'business-directory', emoji: '🏢', label: 'Diretório Empresarial' },
  
  // Websites e Plataformas Online
  { value: 'website', emoji: '🌐', label: 'Website Próprio' },
  { value: 'landing-page', emoji: '🎯', label: 'Landing Page' },
  { value: 'blog', emoji: '📝', label: 'Blog' },
  { value: 'ecommerce', emoji: '🛒', label: 'E-commerce' },
  { value: 'marketplace', emoji: '🏪', label: 'Marketplace' },
  { value: 'amazon', emoji: '📦', label: 'Amazon' },
  { value: 'mercadolivre', emoji: '🛒', label: 'Mercado Livre' },
  { value: 'shopee', emoji: '🛍️', label: 'Shopee' },
  { value: 'magalu', emoji: '🛒', label: 'Magazine Luiza' },
  { value: 'americanas', emoji: '🛒', label: 'Americanas' },
  
  // Email e Marketing Digital
  { value: 'email-marketing', emoji: '📧', label: 'Email Marketing' },
  { value: 'newsletter', emoji: '📰', label: 'Newsletter' },
  { value: 'newsletter-signup', emoji: '📝', label: 'Cadastro Newsletter' },
  { value: 'lead-magnet', emoji: '🧲', label: 'Lead Magnet' },
  { value: 'webinar', emoji: '🎓', label: 'Webinar' },
  { value: 'live', emoji: '📺', label: 'Live' },
  { value: 'podcast', emoji: '🎙️', label: 'Podcast' },
  { value: 'youtube-channel', emoji: '📺', label: 'Canal YouTube' },
  
  // Publicidade e Anúncios
  { value: 'google-ads', emoji: '🎯', label: 'Google Ads' },
  { value: 'facebook-ads', emoji: '📘', label: 'Facebook Ads' },
  { value: 'instagram-ads', emoji: '📷', label: 'Instagram Ads' },
  { value: 'linkedin-ads', emoji: '💼', label: 'LinkedIn Ads' },
  { value: 'youtube-ads', emoji: '📺', label: 'YouTube Ads' },
  { value: 'tiktok-ads', emoji: '🎵', label: 'TikTok Ads' },
  { value: 'display-ads', emoji: '🖼️', label: 'Display Ads' },
  { value: 'retargeting', emoji: '🔄', label: 'Remarketing' },
  { value: 'affiliate', emoji: '🤝', label: 'Afiliado' },
  { value: 'influencer', emoji: '⭐', label: 'Influencer' },
  
  // Eventos e Networking
  { value: 'event', emoji: '🎪', label: 'Evento' },
  { value: 'conference', emoji: '🎤', label: 'Conferência' },
  { value: 'workshop', emoji: '🔧', label: 'Workshop' },
  { value: 'seminar', emoji: '🎓', label: 'Seminário' },
  { value: 'networking', emoji: '🤝', label: 'Networking' },
  { value: 'trade-show', emoji: '🏢', label: 'Feira' },
  { value: 'exhibition', emoji: '🎨', label: 'Exposição' },
  { value: 'meetup', emoji: '👥', label: 'Meetup' },
  { value: 'business-lunch', emoji: '🍽️', label: 'Almoço de Negócios' },
  
  // Indicações e Referências
  { value: 'referral', emoji: '👥', label: 'Indicação' },
  { value: 'word-of-mouth', emoji: '🗣️', label: 'Boca a Boca' },
  { value: 'recommendation', emoji: '👍', label: 'Recomendação' },
  { value: 'partner', emoji: '🤝', label: 'Parceiro' },
  { value: 'client-referral', emoji: '👤', label: 'Indicação de Cliente' },
  { value: 'supplier-referral', emoji: '🏭', label: 'Indicação de Fornecedor' },
  { value: 'employee-referral', emoji: '👨‍💼', label: 'Indicação de Funcionário' },
  
  // Canais Tradicionais
  { value: 'phone', emoji: '📞', label: 'Telefone' },
  { value: 'walk-in', emoji: '🚶', label: 'Visita Espontânea' },
  { value: 'store-visit', emoji: '🏪', label: 'Visita à Loja' },
  { value: 'office-visit', emoji: '🏢', label: 'Visita ao Escritório' },
  { value: 'mail', emoji: '📮', label: 'Correio' },
  { value: 'fax', emoji: '📠', label: 'Fax' },
  { value: 'radio', emoji: '📻', label: 'Rádio' },
  { value: 'tv', emoji: '📺', label: 'TV' },
  { value: 'newspaper', emoji: '📰', label: 'Jornal' },
  { value: 'magazine', emoji: '📖', label: 'Revista' },
  { value: 'billboard', emoji: '🪧', label: 'Outdoor' },
  { value: 'flyer', emoji: '📄', label: 'Panfleto' },
  { value: 'brochure', emoji: '📋', label: 'Brochura' },
  
  // Outros Canais Digitais
  { value: 'app-store', emoji: '📱', label: 'App Store' },
  { value: 'play-store', emoji: '📱', label: 'Google Play' },
  { value: 'qr-code', emoji: '📱', label: 'QR Code' },
  { value: 'nfc', emoji: '📱', label: 'NFC' },
  { value: 'beacon', emoji: '📡', label: 'Beacon' },
  { value: 'chatbot', emoji: '🤖', label: 'Chatbot' },
  { value: 'live-chat', emoji: '💬', label: 'Chat Online' },
  { value: 'support-ticket', emoji: '🎫', label: 'Ticket de Suporte' },
  
  // Canais Específicos por Setor
  { value: 'real-estate', emoji: '🏠', label: 'Imobiliário' },
  { value: 'automotive', emoji: '🚗', label: 'Automotivo' },
  { value: 'healthcare', emoji: '🏥', label: 'Saúde' },
  { value: 'education', emoji: '🎓', label: 'Educação' },
  { value: 'finance', emoji: '💰', label: 'Financeiro' },
  { value: 'insurance', emoji: '🛡️', label: 'Seguros' },
  { value: 'legal', emoji: '⚖️', label: 'Jurídico' },
  { value: 'consulting', emoji: '💼', label: 'Consultoria' },
  { value: 'technology', emoji: '💻', label: 'Tecnologia' },
  { value: 'retail', emoji: '🛍️', label: 'Varejo' },
  
  // Outros
  { value: 'other', emoji: '❓', label: 'Outros' },
  { value: 'unknown', emoji: '❔', label: 'Desconhecido' },
  { value: 'competitor', emoji: '⚔️', label: 'Concorrente' },
  { value: 'research', emoji: '🔍', label: 'Pesquisa Própria' },
  { value: 'cold-call', emoji: '❄️', label: 'Cold Call' },
  { value: 'cold-email', emoji: '📧', label: 'Cold Email' }
]

// Métodos
const getIconEmoji = (iconValue) => {
  const icon = availableIcons.find(i => i.value === iconValue)
  return icon ? icon.emoji : '🏷️'
}

// Função para detectar se uma cor é clara ou escura
const isLightColor = (hexColor) => {
  // Remove o # se presente
  const hex = hexColor.replace('#', '')
  
  // Converte para RGB
  const r = parseInt(hex.substr(0, 2), 16)
  const g = parseInt(hex.substr(2, 2), 16)
  const b = parseInt(hex.substr(4, 2), 16)
  
  // Calcula o brilho usando a fórmula de luminância
  const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000
  
  // Se o brilho for maior que 128, a cor é clara
  return brightness > 128
}

// Função para obter a cor do texto baseada na cor de fundo
const getTextColor = (backgroundColor) => {
  return isLightColor(backgroundColor) ? '#000000' : '#FFFFFF'
}

// Função para obter a cor de fundo dos botões baseada na cor da tag
const getButtonBackgroundColor = (backgroundColor) => {
  return isLightColor(backgroundColor) ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)'
}

// Função para obter a cor de hover dos botões
const getButtonHoverColor = (backgroundColor) => {
  return isLightColor(backgroundColor) ? 'rgba(0, 0, 0, 0.3)' : 'rgba(255, 255, 255, 0.3)'
}

const parseTaskEditFieldsJson = (jsonValue) => {
  const defaultsDesktop = getDefaultTaskLayout()
  const defaultsMobile = getDefaultTaskLayoutMobile()
  if (!jsonValue || typeof jsonValue !== 'string') {
    return { desktop: defaultsDesktop, mobile: defaultsMobile }
  }

  try {
    const parsed = JSON.parse(jsonValue)
    const layout = parsed?.layout
    if (!layout) return { desktop: defaultsDesktop, mobile: defaultsMobile }

    const enabledMapDesktop = layout?.enabled || {}
    const col1Ids = Array.isArray(layout?.columns?.col1) ? layout.columns.col1 : defaultsDesktop.col1.map((i) => i.id)
    const col2Ids = Array.isArray(layout?.columns?.col2) ? layout.columns.col2 : defaultsDesktop.col2.map((i) => i.id)

    const validIds = new Set(getAvailableTaskFieldIds())
    const buildColumn = (ids, fallbackColumn, enabledMap) => {
      const unique = [...new Set(ids)].filter((id) => validIds.has(id))
      if (unique.length === 0) {
        return fallbackColumn.map((item) => buildTaskField(item.id, enabledMap[item.id] !== false))
      }
      return unique.map((id) => buildTaskField(id, enabledMap[id] !== false))
    }

    const mergedCol1 = buildColumn(col1Ids, defaultsDesktop.col1, enabledMapDesktop)
    const used = new Set(mergedCol1.map((i) => i.id))
    const mergedCol2Base = buildColumn(col2Ids, defaultsDesktop.col2, enabledMapDesktop).filter((i) => !used.has(i.id))
    const missing = getAvailableTaskFieldIds()
      .filter((id) => !used.has(id) && !mergedCol2Base.some((c) => c.id === id))
      .map((id) => buildTaskField(id, enabledMapDesktop[id] !== false))

    const mobile = layout?.mobile || {}
    const enabledMapMobile = mobile?.enabled || enabledMapDesktop
    const mobileIds = Array.isArray(mobile?.columns?.col1)
      ? mobile.columns.col1
      : [...mergedCol1, ...mergedCol2Base, ...missing].map((item) => item.id)
    const mergedMobileCol1 = buildColumn(mobileIds, defaultsMobile.col1, enabledMapMobile)

    return {
      desktop: {
        col1: mergedCol1,
        col2: [...mergedCol2Base, ...missing],
        chat: { enabled: layout?.chatEnabled !== false }
      },
      mobile: {
        col1: mergedMobileCol1,
        chat: { enabled: (mobile?.chatEnabled ?? layout?.chatEnabled) !== false }
      }
    }
  } catch (error) {
    console.warn('⚠️ taskEditFieldsJson inválido. Aplicando padrão.', error)
    return { desktop: defaultsDesktop, mobile: defaultsMobile }
  }
}

const syncTaskLayoutJson = () => {
  const allDesktopCards = [...taskLayout.value.col1, ...taskLayout.value.col2]
  const enabledDesktop = allDesktopCards.reduce((acc, item) => {
    acc[item.id] = item.enabled !== false
    return acc
  }, {})
  enabledDesktop.historicoChat = taskLayout.value.chat.enabled !== false

  const allMobileCards = [...taskLayoutMobile.value.col1]
  const enabledMobile = allMobileCards.reduce((acc, item) => {
    acc[item.id] = item.enabled !== false
    return acc
  }, {})
  enabledMobile.historicoChat = taskLayoutMobile.value.chat.enabled !== false

  uiConfig.value.taskEditFieldsJson = JSON.stringify({
    layout: {
      columns: {
        col1: taskLayout.value.col1.map((item) => item.id),
        col2: taskLayout.value.col2.map((item) => item.id),
        col3: ['historicoChat']
      },
      enabled: enabledDesktop,
      chatEnabled: taskLayout.value.chat.enabled !== false,
      mobile: {
        columns: {
          col1: taskLayoutMobile.value.col1.map((item) => item.id)
        },
        enabled: enabledMobile,
        chatEnabled: taskLayoutMobile.value.chat.enabled !== false
      }
    }
  }, null, 2)
}

const toggleTaskField = (fieldId, mode = 'desktop') => {
  const allCards = mode === 'mobile'
    ? [...taskLayoutMobile.value.col1]
    : [...taskLayout.value.col1, ...taskLayout.value.col2]
  const found = allCards.find((item) => item.id === fieldId)
  if (!found) return
  found.enabled = !found.enabled
  syncTaskLayoutJson()
}

const toggleChatCard = (mode = 'desktop') => {
  if (mode === 'mobile') {
    taskLayoutMobile.value.chat.enabled = !taskLayoutMobile.value.chat.enabled
  } else {
    taskLayout.value.chat.enabled = !taskLayout.value.chat.enabled
  }
  syncTaskLayoutJson()
}

const parseCustomFormsJson = (jsonValue) => {
  if (!jsonValue || typeof jsonValue !== 'string') return []
  try {
    const parsed = JSON.parse(jsonValue)
    const groups = Array.isArray(parsed?.groups)
      ? parsed.groups
      : (Array.isArray(parsed?.forms) ? parsed.forms : [])

    return groups.map((group, idx) => ({
      id: group.id || `g_import_${idx}_${Date.now()}`,
      nome: group.nome || `Grupo ${idx + 1}`,
      campos: Array.isArray(group.campos)
        ? group.campos.map((field, fIdx) => ({
            id: field.id || `f_import_${idx}_${fIdx}_${Date.now()}`,
            tipo: ['input', 'textarea', 'date', 'checkbox', 'toggle', 'select'].includes(field.tipo) ? field.tipo : 'input',
            label: field.label || '',
            opcoes: Array.isArray(field.opcoes) ? field.opcoes.join(', ') : (field.opcoes || '')
          }))
        : []
    }))
  } catch (error) {
    console.warn('⚠️ customFormsJson inválido. Aplicando vazio.', error)
    return []
  }
}

const syncCustomFormsJson = () => {
  const normalized = customFormGroups.value.map((group) => ({
    id: group.id,
    nome: group.nome || 'Grupo sem nome',
    campos: (group.campos || []).map((field) => ({
      id: field.id,
      tipo: field.tipo,
      label: field.label || 'Campo sem label',
      opcoes: field.tipo === 'select' ? parseSelectOptions(field.opcoes) : []
    }))
  }))

  uiConfig.value.customFormsJson = JSON.stringify({
    groups: normalized
  }, null, 2)
}

const addCustomFormGroup = () => {
  customFormGroups.value.push(createEmptyCustomGroup())
  syncCustomFormsJson()
  reconcileTaskLayoutWithCustomGroups()
}

const removeCustomFormGroup = (groupId) => {
  customFormGroups.value = customFormGroups.value.filter((group) => group.id !== groupId)
  syncCustomFormsJson()
  reconcileTaskLayoutWithCustomGroups()
}

const addCustomField = (groupId) => {
  const group = customFormGroups.value.find((item) => item.id === groupId)
  if (!group) return
  group.campos = group.campos || []
  group.campos.push(createEmptyCustomField())
  syncCustomFormsJson()
}

const removeCustomField = (groupId, fieldId) => {
  const group = customFormGroups.value.find((item) => item.id === groupId)
  if (!group) return
  group.campos = (group.campos || []).filter((field) => field.id !== fieldId)
  syncCustomFormsJson()
}

const parseSelectOptions = (optionsText) => {
  return String(optionsText || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
}

const openCustomFormsPreview = () => {
  syncCustomFormsJson()
  showCustomFormsPreview.value = true
}

const onCustomGroupNameInput = () => {
  syncCustomFormsJson()
  reconcileTaskLayoutWithCustomGroups()
}

const parseTaskPreviewJson = (jsonValue) => {
  const defaults = getDefaultPreviewSettings()
  if (!jsonValue || typeof jsonValue !== 'string') return defaults

  try {
    const parsed = JSON.parse(jsonValue)
    const visibility = parsed?.visibility
    if (!visibility || typeof visibility !== 'object') return defaults

    return previewOptions.value.reduce((acc, option) => {
      acc[option.key] = visibility[option.key] !== false
      return acc
    }, { ...defaults })
  } catch (error) {
    console.warn('⚠️ taskPreviewJson inválido. Aplicando padrão.', error)
    return defaults
  }
}

const syncTaskPreviewJson = () => {
  uiConfig.value.taskPreviewJson = JSON.stringify({
    visibility: { ...previewSettings.value }
  }, null, 2)
}

const togglePreviewSetting = (key) => {
  if (!Object.prototype.hasOwnProperty.call(previewSettings.value, key)) return
  previewSettings.value[key] = !previewSettings.value[key]
  syncTaskPreviewJson()
}

const loadConfiguracoes = async () => {
  loading.value = true
  try {
    console.log('🔧 Carregando configurações para workspace:', workspaceId.value)
    
    // Carregar categorias
    const uiConfigResponse = await api.get(`/workspace-config/${workspaceId.value}/ui-config`)
    uiConfig.value = {
      taskEditFieldsJson: uiConfigResponse.data?.taskEditFieldsJson || '{}',
      kanbanFiltersJson: uiConfigResponse.data?.kanbanFiltersJson || '{}',
      screenPreferencesJson: uiConfigResponse.data?.screenPreferencesJson || '{}',
      customFormsJson: uiConfigResponse.data?.customFormsJson || '{}',
      taskPreviewJson: uiConfigResponse.data?.taskPreviewJson || '{}'
    }
    customFormGroups.value = parseCustomFormsJson(uiConfig.value.customFormsJson)
    syncCustomFormsJson()
    const parsedTaskLayout = parseTaskEditFieldsJson(uiConfig.value.taskEditFieldsJson)
    taskLayout.value = parsedTaskLayout.desktop
    taskLayoutMobile.value = parsedTaskLayout.mobile
    reconcileTaskLayoutWithCustomGroups()
    syncTaskLayoutJson()
    previewSettings.value = parseTaskPreviewJson(uiConfig.value.taskPreviewJson)
    syncTaskPreviewJson()

    // Carregar categorias
    const categoriasResponse = await api.get(`/workspace-config/${workspaceId.value}/categorias`)
    console.log('📋 Resposta categorias:', categoriasResponse.data)
    categorias.value = categoriasResponse.data || []

    // Carregar motivos de agendamento para TAREFAS e CRM
    const motivosResponse = await api.get(`/workspace-config/${workspaceId.value}/motivos-agendamento`)
    motivosAgendamento.value = motivosResponse.data || []

    // Carregar origens de lead apenas se for CRM
    if (currentWorkspace.value?.tipo === 'CRM') {
      const origensResponse = await api.get(`/workspace-config/${workspaceId.value}/origens-lead`)
      origensLead.value = origensResponse.data || []
    }
    
    console.log('✅ Configurações carregadas com sucesso')
  } catch (error) {
    console.error('❌ Erro ao carregar configurações:', error)
  } finally {
    loading.value = false
  }
}

const salvarUiConfig = async () => {
  loading.value = true
  try {
    syncTaskLayoutJson()
    syncCustomFormsJson()
    syncTaskPreviewJson()
    await api.put(`/workspace-config/${workspaceId.value}/ui-config`, uiConfig.value)
    await loadConfiguracoes()
  } catch (error) {
    console.error('Erro ao salvar configuração avançada:', error)
    Swal.fire({
      title: t('configuracoes.swal.errorTitle'),
      text: t('configuracoes.swal.advancedSaveError'),
      icon: 'error'
    })
  } finally {
    loading.value = false
  }
}

const criarCategoria = async () => {
  loading.value = true
  try {
    console.log('🔧 FRONTEND: Criando categoria...')
    console.log('🔧 FRONTEND: Dados enviados:', novaCategoria.value)
    
    const response = await api.post(`/workspace-config/${workspaceId.value}/categorias`, novaCategoria.value)
    console.log('✅ FRONTEND: Categoria criada com sucesso!')
    console.log('✅ FRONTEND: Resposta do servidor:', response.data)
    
    // Adicionar a categoria criada diretamente à lista local com o ID retornado
    const novaCategoriaComId = response.data
    categorias.value.push(novaCategoriaComId)
    
    // Limpar formulário e fechar modal
    novaCategoria.value = { nome: '', descricao: '', cor: '#5865F2', icone: '', ordem: 0 }
    showCreateCategoriaModal.value = false
    
    console.log('✅ FRONTEND: Categoria adicionada à lista local com ID:', novaCategoriaComId.id)
  } catch (error) {
    console.error('❌ FRONTEND: Erro ao criar categoria:', error)
    console.error('❌ FRONTEND: Dados enviados:', novaCategoria.value)
    console.error('❌ FRONTEND: Resposta do servidor:', error.response?.data)
    console.error('❌ FRONTEND: Status HTTP:', error.response?.status)
    
    // Em caso de erro, recarregar as configurações para garantir consistência
    await loadConfiguracoes()
  } finally {
    loading.value = false
  }
}

const criarTag = async () => {
  loading.value = true
  try {
    console.log('🔧 FRONTEND: Criando tag...')
    const tagData = {
      ...novaTag.value,
      categoriaId: selectedCategoria.value.id
    }
    console.log('🔧 FRONTEND: Dados da tag enviados:', tagData)
    
    const response = await api.post(`/workspace-config/${workspaceId.value}/tags`, tagData)
    console.log('✅ FRONTEND: Tag criada com sucesso!')
    console.log('✅ FRONTEND: Resposta do servidor:', response.data)
    
    // Atualizar a categoria local com a nova tag
    const categoriaIndex = categorias.value.findIndex(c => c.id === selectedCategoria.value.id)
    if (categoriaIndex !== -1) {
      if (!categorias.value[categoriaIndex].tags) {
        categorias.value[categoriaIndex].tags = []
      }
      // Garantir que a tag tenha o ID correto antes de adicionar
      const novaTagComId = {
        ...response.data,
        id: response.data.id // Garantir que o ID está presente
      }
      categorias.value[categoriaIndex].tags.push(novaTagComId)
      console.log('✅ FRONTEND: Tag adicionada com ID:', novaTagComId.id)
    }
    
    // Limpar formulário e fechar modal
    novaTag.value = { nome: '', cor: '#5865F2', icone: '' }
    selectedCategoria.value = null
    showCreateTagModal.value = false
    
    console.log('✅ FRONTEND: Tag adicionada à categoria local com ID:', response.data.id)
    
    // Pequeno delay para garantir que o backend processou tudo
    await new Promise(resolve => setTimeout(resolve, 100))
  } catch (error) {
    console.error('❌ FRONTEND: Erro ao criar tag:', error)
    console.error('❌ FRONTEND: Dados enviados:', tagData)
    console.error('❌ FRONTEND: Resposta do servidor:', error.response?.data)
    
    // Em caso de erro, recarregar as configurações para garantir consistência
    await loadConfiguracoes()
  } finally {
    loading.value = false
  }
}

const editCategoria = (categoria) => {
  categoriaEditando.value = { ...categoria }
  showEditCategoriaModal.value = true
}

const atualizarCategoria = async () => {
  if (!categoriaEditando.value.nome) return
  
  loading.value = true
  try {
    const categoriaData = {
      nome: categoriaEditando.value.nome,
      descricao: categoriaEditando.value.descricao,
      cor: categoriaEditando.value.cor,
      icone: categoriaEditando.value.icone,
      ordem: categoriaEditando.value.ordem || 0
    }
    
    await api.put(`/workspace-config/${workspaceId.value}/categorias/${categoriaEditando.value.id}`, categoriaData)
    showEditCategoriaModal.value = false
    await loadConfiguracoes()
  } catch (error) {
    console.error('Erro ao atualizar categoria:', error)
    Swal.fire({
      title: t('configuracoes.swal.errorTitle'),
      text: t('configuracoes.swal.categoryUpdateError'),
      icon: 'error'
    })
  } finally {
    loading.value = false
  }
}

const deleteCategoria = async (categoriaId) => {
  const categoria = categorias.value.find(c => c.id === categoriaId)
  const categoriaNome = categoria ? categoria.nome : ''

  
  const result = await Swal.fire({
    title: t('configuracoes.swal.confirmDeleteTitle'),
    text: t('configuracoes.swal.confirmDeleteCategory', { name: categoriaNome }),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc2626',
    cancelButtonColor: '#6b7280',
    confirmButtonText: t('configuracoes.swal.confirmYesDelete'),
    cancelButtonText: t('common.cancel'),
    reverseButtons: true
  })

  if (result.isConfirmed) {
    loading.value = true
    try {
      console.log('🗑️ FRONTEND: DELETANDO CATEGORIA:', categoriaId)
      console.log('🗑️ FRONTEND: URL:', `/workspace-config/${workspaceId.value}/categorias/${categoriaId}`)
      
      await api.delete(`/workspace-config/${workspaceId.value}/categorias/${categoriaId}`)
      
      console.log('✅ FRONTEND: CATEGORIA DELETADA COM SUCESSO')
      await loadConfiguracoes()
      
      Swal.fire({
        title: t('configuracoes.swal.deletedTitle'),
        text: t('configuracoes.swal.categoryDeleted'),
        icon: 'success',
        timer: 2000,
        showConfirmButton: false
      })
    } catch (error) {
      console.error('❌ FRONTEND: ERRO AO DELETAR CATEGORIA:', error)
      console.error('❌ FRONTEND: Status:', error.response?.status)
      console.error('❌ FRONTEND: Data:', error.response?.data)
      
      Swal.fire({
        title: t('configuracoes.swal.errorTitle'),
        text: t('configuracoes.swal.categoryDeleteError'),
        icon: 'error'
      })
    } finally {
      loading.value = false
    }
  }
}

// ===== MOTIVOS DE AGENDAMENTO =====
const criarMotivo = async () => {
  loading.value = true
  try {
    const payload = {
      motivo: novoMotivo.value.motivo,
      cor: novoMotivo.value.cor,
      icone: novoMotivo.value.icone
    }
    await api.post(`/workspace-config/${workspaceId.value}/motivos-agendamento`, payload)
    // Limpar e fechar
    novoMotivo.value = { motivo: '', cor: '#5865F2', icone: '' }
    showCreateMotivoModal.value = false
    await loadConfiguracoes()
  } catch (error) {
    console.error('Erro ao criar motivo:', error)
    Swal.fire({ title: t('configuracoes.swal.errorTitle'), text: t('configuracoes.swal.motivoCreateError'), icon: 'error' })
  } finally {
    loading.value = false
  }
}

const editMotivo = (motivo) => {
  motivoEditando.value = { id: motivo.id, motivo: motivo.motivo, cor: motivo.cor || '#5865F2', icone: motivo.icone || '' }
  showEditMotivoModal.value = true
}

const atualizarMotivo = async () => {
  if (!motivoEditando.value.motivo) return
  loading.value = true
  try {
    const payload = {
      motivo: motivoEditando.value.motivo,
      cor: motivoEditando.value.cor,
      icone: motivoEditando.value.icone
    }
    await api.put(`/workspace-config/${workspaceId.value}/motivos-agendamento/${motivoEditando.value.id}`, payload)
    showEditMotivoModal.value = false
    await loadConfiguracoes()
  } catch (error) {
    console.error('Erro ao atualizar motivo:', error)
    Swal.fire({ title: t('configuracoes.swal.errorTitle'), text: t('configuracoes.swal.motivoUpdateError'), icon: 'error' })
  } finally {
    loading.value = false
  }
}

// ===== ORIGENS DE LEAD =====
const criarOrigem = async () => {
  loading.value = true
  try {
    const payload = {
      origem: novaOrigem.value.origem,
      icone: novaOrigem.value.icone
    }
    await api.post(`/workspace-config/${workspaceId.value}/origens-lead`, payload)
    // Limpar e fechar
    novaOrigem.value = { origem: '', icone: '' }
    showCreateOrigemModal.value = false
    await loadConfiguracoes()
  } catch (error) {
    console.error('Erro ao criar origem:', error)
    Swal.fire({ title: t('configuracoes.swal.errorTitle'), text: t('configuracoes.swal.origemCreateError'), icon: 'error' })
  } finally {
    loading.value = false
  }
}

const editOrigem = (origem) => {
  origemEditando.value = { id: origem.id, origem: origem.origem, icone: origem.icone || '' }
  showEditOrigemModal.value = true
}

const atualizarOrigem = async () => {
  if (!origemEditando.value.origem) return
  loading.value = true
  try {
    const payload = {
      origem: origemEditando.value.origem,
      icone: origemEditando.value.icone
    }
    await api.put(`/workspace-config/${workspaceId.value}/origens-lead/${origemEditando.value.id}`, payload)
    showEditOrigemModal.value = false
    await loadConfiguracoes()
  } catch (error) {
    console.error('Erro ao atualizar origem:', error)
    Swal.fire({ title: t('configuracoes.swal.errorTitle'), text: t('configuracoes.swal.origemUpdateError'), icon: 'error' })
  } finally {
    loading.value = false
  }
}

const editTag = (tag) => {
  tagEditando.value = { ...tag }
  showEditTagModal.value = true
}

const atualizarTag = async () => {
  if (!tagEditando.value.nome) return
  
  loading.value = true
  try {
    const tagData = {
      nome: tagEditando.value.nome,
      cor: tagEditando.value.cor,
      icone: tagEditando.value.icone,
      categoriaId: tagEditando.value.categoriaId
    }
    
    await api.put(`/workspace-config/${workspaceId.value}/tags/${tagEditando.value.id}`, tagData)
    showEditTagModal.value = false
    await loadConfiguracoes()
  } catch (error) {
    console.error('Erro ao atualizar tag:', error)
    Swal.fire({ title: t('configuracoes.swal.errorTitle'), text: t('configuracoes.swal.tagUpdateError'), icon: 'error' })
  } finally {
    loading.value = false
  }
}

const deleteTag = async (tagId) => {
  console.log('🗑️ FRONTEND: Tentando deletar tag com ID:', tagId)
  
  // Encontrar a tag para obter informações
  let tag = null
  let categoriaNome = 'categoria'
  
  for (const categoria of categorias.value) {
    if (categoria.tags) {
      tag = categoria.tags.find(t => t.id === tagId)
      if (tag) {
        categoriaNome = categoria.nome
        console.log('🔍 FRONTEND: Tag encontrada:', tag)
        console.log('🔍 FRONTEND: Categoria:', categoriaNome)
        break
      }
    }
  }
  
  const tagNome = tag ? tag.nome : ''
  console.log('🔍 FRONTEND: Tag nome:', tagNome)
  
  const result = await Swal.fire({
    title: t('configuracoes.swal.confirmDeleteTitle'),
    text: t('configuracoes.swal.confirmDeleteTag', { name: tagNome }),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc2626',
    cancelButtonColor: '#6b7280',
    confirmButtonText: t('configuracoes.swal.confirmYesDelete'),
    cancelButtonText: t('common.cancel'),
    reverseButtons: true
  })

  if (result.isConfirmed) {
    loading.value = true
    try {
      console.log('🗑️ FRONTEND: DELETANDO TAG:', tagId)
      console.log('🗑️ FRONTEND: URL:', `/workspace-config/${workspaceId.value}/tags/${tagId}`)
      
      await api.delete(`/workspace-config/${workspaceId.value}/tags/${tagId}`)
      
      console.log('✅ FRONTEND: TAG DELETADA COM SUCESSO')
      await loadConfiguracoes()
      
      Swal.fire({
        title: t('configuracoes.swal.deletedTitle'),
        text: t('configuracoes.swal.tagDeleted'),
        icon: 'success',
        timer: 2000,
        showConfirmButton: false
      })
    } catch (error) {
      console.error('❌ FRONTEND: ERRO AO DELETAR TAG:', error)
      console.error('❌ FRONTEND: Status:', error.response?.status)
      console.error('❌ FRONTEND: Data:', error.response?.data)
      
      Swal.fire({
        title: t('configuracoes.swal.errorTitle'),
        text: t('configuracoes.swal.tagDeleteError'),
        icon: 'error'
      })
    } finally {
      loading.value = false
    }
  }
}

const deleteMotivo = async (motivoId) => {
  if (!confirm(t('configuracoes.swal.confirmDeleteMotivo'))) return
  
  loading.value = true
  try {
    await api.delete(`/workspace-config/${workspaceId.value}/motivos-agendamento/${motivoId}`)
    await loadConfiguracoes()
  } catch (error) {
    console.error('Erro ao deletar motivo:', error)
  } finally {
    loading.value = false
  }
}

const deleteOrigem = async (origemId) => {
  if (!confirm(t('configuracoes.swal.confirmDeleteOrigem'))) return
  
  loading.value = true
  try {
    await api.delete(`/workspace-config/${workspaceId.value}/origens-lead/${origemId}`)
    await loadConfiguracoes()
  } catch (error) {
    console.error('Erro ao deletar origem:', error)
  } finally {
    loading.value = false
  }
}

const importarConfiguracoes = async () => {
  loading.value = true
  try {
    await api.post(`/workspace-config/${workspaceId.value}/importar`, {
      workspaceOrigemId: parseInt(importWorkspaceId.value)
    })
    importWorkspaceId.value = ''
    showImportModal.value = false
    await loadConfiguracoes()
  } catch (error) {
    console.error('Erro ao importar configurações:', error)
  } finally {
    loading.value = false
  }
}

watch(
  () => uiConfig.value.taskPreviewJson,
  (newValue) => {
    previewSettings.value = parseTaskPreviewJson(newValue)
  }
)

// Lifecycle
onMounted(async () => {
  await ensureAccess(workspaceId.value)
  if (staffDenied.value) return
  const { loadWorkspaces } = useGlobalWorkspaces()
  await loadWorkspaces()
  if (workspaceId.value) {
    await planoFeatures.loadForWorkspace(workspaceId.value)
  }
  await loadConfiguracoes()
})

// Watch para reagir quando currentWorkspace mudar
watch(currentWorkspace, async (newWorkspace) => {
  if (newWorkspace && newWorkspace.id) {
    console.log('🔄 Workspace mudou, recarregando configurações:', newWorkspace)
    await loadConfiguracoes()
  }
}, { immediate: false })
</script>

<style scoped>
.workspace-configuracoes-page {
  padding: 0;
  min-height: 100vh;
  background: linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%);
}

/* Header Moderno */
.modern-header {
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-primary);
  padding: 24px 0;
  margin-bottom: 24px;
}

.header-container {
  width: 100%;
  padding: 0 24px;
}

/* Breadcrumb */
.breadcrumb-section {
  margin-bottom: 16px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
}

.breadcrumb-item:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.breadcrumb-separator {
  color: var(--text-tertiary);
  font-weight: 500;
}

.breadcrumb-current {
  color: var(--text-primary);
  font-weight: 600;
  padding: 6px 12px;
  background: var(--bg-secondary);
  border-radius: 4px;
}

/* Título e informações */
.title-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.title-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, var(--accent-primary) 0%, #7c3aed 100%);
  border-radius: 4px;
  color: white;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.title-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.main-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.2;
}

.subtitle {
  font-size: 1rem;
  color: var(--text-secondary);
  margin: 0;
  font-weight: 400;
}

/* Badge do workspace */
.workspace-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.workspace-badge.type-crm {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.workspace-badge.type-tarefas {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.badge-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-text {
  font-weight: 600;
}

/* Ações do header */
.actions-section {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
}

.workspace-id-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 500;
  flex-shrink: 0;
  user-select: all;
}

.workspace-id-chip__value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: 0.02em;
}

.action-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.action-button.primary {
  background: linear-gradient(135deg, var(--accent-primary) 0%, #7c3aed 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
}

.action-button.primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
}

.action-button.secondary {
  background: var(--bg-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
}

.action-button.secondary:hover {
  background: var(--bg-tertiary);
  transform: translateY(-1px);
}

.action-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.import-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--info);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 20px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.import-btn:hover:not(:disabled) {
  background: #2563eb;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.4);
}

.import-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Conteúdo Principal */
.page-content {
  width: 100%;
  padding: 0 24px 32px 24px;
}

.config-sections {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.config-section {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  padding: 24px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Força título + descrição empilhados (descrição embaixo do h2) */
.config-section .section-title .title-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
}

.title-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, var(--info) 0%, var(--success) 100%);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.title-content h2 {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 4px 0;
}

.title-content p {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
}

.add-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--success);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 16px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.add-btn:hover {
  background: #16a34a;
  transform: translateY(-1px);
}

/* Grid de Categorias */
.categorias-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
}

.categoria-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
  border-radius: 4px;
  padding: 20px;
  transition: all 0.3s ease;
}

.categoria-card:hover {
  border-color: var(--info);
  box-shadow: 0 8px 32px rgba(59, 130, 246, 0.1);
  transform: translateY(-2px);
}

.categoria-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.categoria-info {
  display: flex;
  gap: 12px;
  flex: 1;
}

.categoria-icon {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  flex-shrink: 0;
}

.categoria-details h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 4px 0;
}

.categoria-details p {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0 0 8px 0;
  line-height: 1.4;
}

.tags-count {
  font-size: 12px;
  color: var(--text-tertiary);
  background: var(--bg-secondary);
  padding: 2px 8px;
  border-radius: 4px;
}

.categoria-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-btn.edit {
  background: var(--warning);
  color: white;
}

.action-btn.edit:hover {
  background: #d97706;
}

.action-btn.delete {
  background: var(--error);
  color: white;
}

.action-btn.delete:hover {
  background: #dc2626;
}

/* Tags Container */
.tags-container {
  border-top: 1px solid var(--border-secondary);
  padding-top: 16px;
}

.tags-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.tags-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.add-tag-btn {
  width: 24px;
  height: 24px;
  background: var(--info);
  color: white;
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-tag-btn:hover {
  background: #2563eb;
}

.tags-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}

.tag-item {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 6px 10px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}

.tag-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transform: translateY(-1px);
}

.tag-icon {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
  color: white;
  font-weight: bold;
}

.tag-name {
  font-size: 12px;
  font-weight: 600;
  flex: 1;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.tag-actions {
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.tag-item:hover .tag-actions {
  opacity: 1;
}

.tag-action-btn {
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tag-action-btn:hover {
  transform: scale(1.1);
}

.tag-action-btn.edit:hover {
  background: rgba(255, 193, 7, 0.8) !important;
  color: #000000 !important;
}

.tag-action-btn.delete:hover {
  background: rgba(220, 53, 69, 0.8) !important;
  color: #FFFFFF !important;
}

/* Preview da Tag */
.tag-preview {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.tag-item-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 6px 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  justify-content: center;
}

.tag-icon-preview {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
  font-weight: bold;
}

.tag-name-preview {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.preview-helper-text {
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 12px;
}

.preview-options-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.preview-option-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
  border-radius: 4px;
  padding: 12px;
}

.preview-option-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.preview-option-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.preview-option-desc {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.3;
}

.preview-toggle-switch {
  position: relative;
  width: 44px;
  height: 24px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.preview-toggle-switch.active {
  background: var(--info);
  border-color: var(--info);
}

.preview-toggle-slider {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.preview-toggle-switch.active .preview-toggle-slider {
  transform: translateX(20px);
}

.task-layout-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.task-layout-grid-mobile {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.task-layout-column {
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
  border-radius: 4px;
  padding: 10px;
}

.task-layout-column-header {
  font-size: 12px;
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.task-layout-dropzone {
  min-height: 120px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.task-layout-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.task-layout-card.is-disabled {
  opacity: 0.55;
}

.task-layout-card-main {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}

.task-layout-card-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.task-layout-card-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
}

.task-layout-card-desc {
  font-size: 11px;
  color: var(--text-secondary);
  line-height: 1.25;
}

.drag-handle {
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 4px;
  cursor: grab;
  color: var(--text-tertiary);
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.drag-handle:hover {
  background: var(--bg-tertiary);
}

.drag-handle:active {
  cursor: grabbing;
}

.drag-handle-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.custom-forms-toolbar {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.custom-groups-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.custom-group-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
  border-radius: 4px;
  padding: 12px;
}

.custom-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.custom-group-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.group-drag-handle,
.field-drag-handle {
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 4px;
  color: var(--text-tertiary);
  background: var(--bg-secondary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  flex-shrink: 0;
}

.group-drag-handle:active,
.field-drag-handle:active {
  cursor: grabbing;
}

.custom-fields-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.custom-field-item {
  display: grid;
  grid-template-columns: 26px minmax(120px, 170px) minmax(180px, 1fr) minmax(180px, 1fr) 32px;
  gap: 8px;
  align-items: center;
}

.field-type-select {
  min-width: 120px;
}

.custom-group-actions {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
}

.custom-preview-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.custom-preview-group {
  border: 1px solid var(--border-secondary);
  border-radius: 4px;
  padding: 12px;
  background: var(--bg-primary);
}

.custom-preview-group-title {
  margin: 0 0 10px 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
}

.custom-preview-empty {
  color: var(--text-secondary);
  font-size: 13px;
}

.custom-preview-fields {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.custom-preview-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.custom-preview-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
}

.custom-preview-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--text-primary);
}

.no-tags {
  text-align: center;
  padding: 20px;
  color: var(--text-tertiary);
  font-size: 14px;
}

/* Items Grid (Motivos e Origens) */
.items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
}

.item-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
  border-radius: 4px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
}

.item-card:hover {
  border-color: var(--info);
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.1);
  transform: translateY(-1px);
}

.item-icon {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  flex-shrink: 0;
}

.item-content {
  flex: 1;
}

.item-content h3 {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.item-actions {
  display: flex;
  gap: 6px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.item-card:hover .item-actions {
  opacity: 1;
}

/* Empty States */
.empty-state {
  text-align: center;
  padding: 48px 24px;
  color: var(--text-secondary);
}

.empty-icon {
  color: var(--text-tertiary);
  margin-bottom: 16px;
}

.empty-state h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 8px 0;
}

.empty-state p {
  font-size: 14px;
  margin: 0 0 20px 0;
}

.create-first-btn {
  background: var(--info);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.create-first-btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

/* Subseções */
.subsection {
  margin-bottom: 32px;
}

.subsection:last-child {
  margin-bottom: 0;
}

/* Modais */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0;
  border-bottom: 1px solid var(--border-secondary);
  margin-bottom: 24px;
}

.modal-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.modal-close {
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: var(--bg-primary);
  color: var(--text-primary);
}

.modal-body {
  padding: 0 24px;
}

.form-group {
  margin-bottom: 20px;
}

.advanced-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}

.advanced-tab-btn {
  border: 1px solid var(--border-secondary);
  background: var(--bg-primary);
  color: var(--text-secondary);
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.2px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.advanced-tab-btn:hover {
  border-color: var(--info);
  color: var(--text-primary);
}

.advanced-tab-btn.active {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.16), rgba(99, 102, 241, 0.12));
  border-color: var(--info);
  color: var(--text-primary);
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.22) inset;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.input-field {
  width: 100%;
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
  border-radius: 4px;
  padding: 12px 16px;
  font-size: 14px;
  color: var(--text-primary);
  transition: all 0.2s ease;
}

.input-field:focus {
  outline: none;
  border-color: var(--info);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.color-input {
  width: 60px;
  height: 40px;
  background: none;
  border: 1px solid var(--border-secondary);
  border-radius: 4px;
  cursor: pointer;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 24px;
  border-top: 1px solid var(--border-secondary);
  margin-top: 24px;
}

.btn-primary {
  background: var(--info);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 20px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover:not(:disabled) {
  background: #2563eb;
  transform: translateY(-1px);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  background: var(--bg-primary);
  color: var(--text-secondary);
  border: 1px solid var(--border-secondary);
  border-radius: 4px;
  padding: 12px 20px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

/* Loading */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(59, 130, 246, 0.2);
  border-top: 4px solid var(--info);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsividade */
@media (max-width: 768px) {
  .workspace-configuracoes-page {
    padding: 0;
  }
  
  .modern-header {
    padding: 12px 0;
    margin-bottom: 14px;
  }
  
  .header-container {
    padding: 0 10px;
  }

  .breadcrumb-section {
    margin-bottom: 10px;
  }

  .breadcrumb {
    gap: 4px;
    flex-wrap: wrap;
    font-size: 12px;
  }

  .breadcrumb-item {
    padding: 4px 8px;
    font-size: 12px;
    gap: 4px;
  }

  .breadcrumb-current {
    padding: 4px 8px;
    font-size: 12px;
  }
  
  .title-section {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
    margin-bottom: 12px;
  }

  .title-content {
    width: 100%;
    gap: 10px;
    align-items: center;
  }

  .title-icon {
    width: 40px;
    height: 40px;
    border-radius: 4px;
  }

  .main-title {
    font-size: 1.4rem;
  }

  .subtitle {
    font-size: 0.9rem;
  }

  .workspace-badge {
    width: fit-content;
    align-self: flex-start;
    padding: 6px 10px;
    font-size: 12px;
  }
  
  .actions-section {
    width: 100%;
    justify-content: stretch;
    gap: 8px;
  }

  .action-button {
    flex: 1 1 0;
    justify-content: center;
    padding: 9px 10px;
    font-size: 13px;
  }
  
  .page-content {
    padding: 0 16px 20px 16px;
  }
  
  .config-section {
    padding: 16px;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 14px;
  }

  .section-title {
    display: grid;
    grid-template-columns: 40px minmax(0, 1fr);
    grid-template-areas:
      "icon heading"
      "desc desc";
    align-items: center;
    column-gap: 10px;
    row-gap: 6px;
    width: 100%;
  }

  .section-title .title-icon {
    grid-area: icon;
  }

  .section-title .title-content {
    display: contents;
  }

  .section-title .title-content h2 {
    grid-area: heading;
    margin: 0;
    font-size: 1rem;
    line-height: 1.3;
  }

  .section-title .title-content p {
    grid-area: desc;
    margin: 0;
    font-size: 12px;
    line-height: 1.35;
  }

  .task-layout-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .task-layout-column {
    padding: 8px;
  }

  .task-layout-dropzone {
    min-height: 0;
  }

  .task-layout-card {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .task-layout-card-main {
    width: 100%;
  }

  .preview-toggle-switch {
    align-self: flex-end;
  }

  .custom-forms-toolbar {
    flex-wrap: wrap;
  }

  .custom-group-header {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .custom-field-item {
    grid-template-columns: 1fr;
    gap: 6px;
  }

  .preview-option-item {
    align-items: flex-start;
    gap: 10px;
  }

  .item-actions {
    opacity: 1;
  }
  
  .categorias-grid {
    grid-template-columns: 1fr;
  }
  
  .items-grid {
    grid-template-columns: 1fr;
  }
  
  .modal-content {
    width: 95%;
    margin: 20px;
  }
}

/* Ícones na lista (origens sem fundo = escuro no claro; motivos com cor = branco) */
.tema_clara .item-icon {
  color: var(--text-primary, #1f2937);
}

.tema_clara .item-icon[style*='background'] {
  color: #fff;
}

.tema_clara .item-icon :deep(svg) {
  color: currentColor;
}

.tema_escura .item-icon {
  color: #f9fafb;
}

.tema_escura .item-icon[style*='background'] {
  color: #fff;
}

.tema_escura .item-icon :deep(svg) {
  color: currentColor;
}

/* Cores adaptáveis para ícones nos modais */
.tema_clara .modal-content svg {
  color: #1f2937; /* gray-800 - preto no tema claro */
}

.tema_escura .modal-content svg {
  color: #f9fafb; /* gray-50 - branco no tema escuro */
}
</style>
